import CloseIcon from '@mui/icons-material/Close';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Backdrop, Box, Button, FormLabel, FormGroup, Checkbox, FormControl, FormControlLabel, Autocomplete, Grid, MenuItem, Radio, RadioGroup, Typography } from '@mui/material';
import TextField from '../../../components/SanitizedTextField/SanitizedTextField';
import AppLoader from '../../../components/AppLoader/AppLoader';
import FormSubmissionSuccessDialog from '../../../components/FormSubmissionSuccessDialog/FormSubmissionSuccessDialog';
import { resolveDiscoCompanyCodeForBranding } from '../../../utils/adminCompany';
import {
  buildCustomerIdYupRule,
  isValidCustomerIdLength,
} from '../../../utils/customerIdValidation';
import Select from '@mui/material/Select';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from "yup";
import Error from '../../../components/error/error';
import FESCOLOGO from "../../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from '../../../images/pitc.png';
import pdfIcon from "../../../images/pdfIcon.png";
import MEPCOWaterMark from '../../../images/DiscosWater/mepcco-watermark.png';
import LESCOWaterMark from '../../../images/DiscosWater/lescowatermark.png';
import IESCOWaterMark from '../../../images/DiscosWater/iescowatermark.png';
import FESCOWaterMark from '../../../images/DiscosWater/fesco-watermark.png';
import GEPCOWaterMark from '../../../images/DiscosWater/gepco-watermark.png';
import HAZECOWaterMark from '../../../images/DiscosWater/hazeco-watermark.png';
import HESCOWaterMark from '../../../images/DiscosWater/hesco-watermark.png';
import TESCOWaterMark from '../../../images/DiscosWater/tesco-watermark.png';
import SEPCOWaterMark from '../../../images/DiscosWater/sepco-watermark.png';
import PESCOWaterMark from '../../../images/DiscosWater/pesco-watermark.png';
import QESCOWaterMark from '../../../images/DiscosWater/qesco-watermark.png';
import { cfpBaseUrl } from '../../../network/urls';
import {
  companyShortName,
  getConsumerConnectionStatusMessage,
  getConsumerDetails,
  getMeterType,
  getPhase,
  handleFileUpload,
  isImage,
  isPdf,
  subDivAPI,
  subdivisionName,
} from '../../../services/Functions';
import { documentExtensions, portalName } from '../../../utils/PortalName';
import './ChangeOfAttributesForm.scss';
//jspdf
import { jsPDF } from "jspdf";
import "jspdf-autotable";
//jsbarcode
import JsBarcode from "jsbarcode";
import { useSelector } from 'react-redux';
import StepProgressBar from '../../../components/StepProgressBarForm/StepProgressBar';
import CustomerInformationCard from '../../../components/CustomerInformationCard/CustomerInformationCard';

const TELCO_OPTIONS = [
  { value: '1', label: 'Jazz / Warid' },
  { value: '2', label: 'Ufone / Onic' },
  { value: '3', label: 'Telenor' },
  { value: '4', label: 'Zong' },
  { value: '5', label: 'SCom' },
];

const THEME_SAFE_SELECT_MENU_PROPS = {
  PaperProps: {
    className: 'eops-select-menu-paper',
    sx: {
      backgroundColor: 'var(--eops-bg-form)',
      backgroundImage: 'none',
      color: 'var(--eops-text)',
      border: '1px solid var(--eops-border)',
      '& .MuiMenuItem-root': {
        color: 'var(--eops-text-secondary)',
      },
      '& .MuiMenuItem-root:hover, & .MuiMenuItem-root.Mui-focusVisible': {
        backgroundColor: 'var(--eops-bg-input)',
      },
      '& .MuiMenuItem-root.Mui-selected': {
        backgroundColor: 'rgba(37, 99, 235, 0.22)',
        color: 'var(--eops-text)',
      },
      '& .MuiMenuItem-root.Mui-selected:hover': {
        backgroundColor: 'rgba(37, 99, 235, 0.32)',
      },
    },
  },
};

const DARK_SAFE_SELECT_MENU_PROPS = THEME_SAFE_SELECT_MENU_PROPS;

const ALPHABETIC_NAME_PATTERN = /^[A-Za-z\s]+$/;

const sanitizeAlphabeticNameInput = (value = '') =>
  String(value).replace(/[^A-Za-z\s]/g, '');

let initialValues = {
  iv_application_type: null,
  iv_consumer_id: '',
  iv_reference_number: '',

  iv_connection_type: "",
  iv_tariff_description: '',
  iv_tariff_code: '',

  iv_applicant_name: '',
  iv_father_name: '',
  iv_applicant_cnic: '',
  iv_applicant_phone_no: '',
  iv_applicant_email: '',

  iv_new_name: "",
  iv_new_cnic: "",
  iv_new_email: "",
  iv_new_phone_no: "",
  iv_new_father_name: '',
  iv_relation_type: "",
  iv_load_type: "",
  iv_new_load: "",
  iv_ntn_num: '',

  iv_new_tariff: "",

  iv_applicant_cnic_front: "",
  iv_applicant_cnic_back: "",
  iv_ownership_document: "",
  iv_electricity_bill_document: "",
  iv_fbr_document: "",
  iv_authority_letter: "",

  iv_previous_owner_cnic_front: '',
  iv_previous_owner_cnic_back: '',
  iv_noc_from_previous_owner: '',
  iv_new_owner_affidavite: "",
  iv_additional_civic_document: '',
  iv_any_other_document: '',
  iv_consent_image_change_of_name: '',

  iv_test_report: "",

  iv_other_documents: "",
  iv_meter_type: '',
  iv_phase: '',
  iv_applicant_address: '',
  iv_telco: ''
};

const isChangeOfNameOnlyType = (applicationType) => {
  const type = Array.isArray(applicationType) ? applicationType[0] : applicationType;
  return Number(type) === 1;
};

/** Wiring Test Report required for every COA type except Change of Name (typeId 1). */
const requiresWiringTestReport = (applicationType) => {
  const type = Array.isArray(applicationType) ? applicationType[0] : applicationType;
  if (type == null || type === '') return false;
  return Number(type) !== 1;
};

/** Progress steps for COA form — Wiring Test Report for all types except Change of Name (1). */
const buildCoaStatusBarSteps = (applicationType, previousSteps = []) => {
  const prevStatus = (title1, title2) => {
    const found = previousSteps.find(
      (step) => step.title1 === title1 && step.title2 === title2,
    );
    return found?.status ?? 0;
  };

  const steps = [
    { title1: 'APPLICATION', title2: 'DETAIL', status: prevStatus('APPLICATION', 'DETAIL') },
    { title1: `APPLICANT'S`, title2: 'CNIC', status: prevStatus(`APPLICANT'S`, 'CNIC') },
    { title1: 'PROOF OF', title2: 'OWNERSHIP', status: prevStatus('PROOF OF', 'OWNERSHIP') },
    { title1: 'ELECTRICITY', title2: 'BILL', status: prevStatus('ELECTRICITY', 'BILL') },
  ];

  if (requiresWiringTestReport(applicationType)) {
    steps.push({
      title1: 'WIRING TEST',
      title2: 'REPORT',
      status: prevStatus('WIRING TEST', 'REPORT'),
    });
  }

  steps.push(
    {
      title1: 'FBR',
      title2: 'DOCUMENT',
      status: prevStatus('FBR', 'DOCUMENT'),
    },
    {
      title1: 'ANY OTHER',
      title2: '(OPTIONAL)',
      status: prevStatus('ANY OTHER', '(OPTIONAL)'),
    },
  );

  return steps;
};

const setCoaStepStatusByTitle = (setCoaStatusBarArray, title1, title2, status) => {
  setCoaStatusBarArray((prevArray) => {
    const idx = prevArray.findIndex(
      (step) => step.title1 === title1 && step.title2 === title2,
    );
    if (idx < 0) return prevArray;
    const updatedArray = [...prevArray];
    updatedArray[idx] = { ...updatedArray[idx], status };
    return updatedArray;
  });
};

const getConnectionTypeFromTariffCode = (tariffCode) => {
  const tariffMap = {
    "01": "Domestic",
    "02": "Commercial",
    "03": "Commercial",
    "04": "Industrial",
    "05": "Bulk Supply",
    "06": "Agricultural Tube Wells",
    "07": "Street Lighting",
    "08": "Residential Colonies",
  };
  const code = String(tariffCode ?? "").padStart(2, "0");
  return tariffMap[code] || "General";
};

const normalizeTariffCode = (tariffCode) =>
  String(tariffCode ?? "").trim().padStart(2, "0");

/** Match IBS TARIFF_CODE against getTariffsDetail row. */
const findTariffByCode = (tariffCode, tariffs = []) => {
  if (tariffCode == null || tariffCode === "") return null;
  const code = normalizeTariffCode(tariffCode);
  const raw = String(tariffCode).trim();
  return (
    tariffs.find((t) => {
      const apiCode = String(t.tariffCode ?? "").trim();
      return (
        apiCode.padStart(2, "0") === code ||
        apiCode === raw ||
        String(t.tariffName || "").includes(`(${code})`) ||
        String(t.tariffName || "").includes(`(${raw})`)
      );
    }) || null
  );
};

/** Category from matched getTariffsDetail row (consumerType). */
const getConnectionCategoryFromTariffList = (tariffCode, tariffs = []) => {
  const match = findTariffByCode(tariffCode, tariffs);
  if (!match) return "";
  return (
    match.consumerType ||
    match.connectionType ||
    match.category ||
    match.connectionCategory ||
    ""
  );
};

const resolveTariffNameFromList = (tariffCode, tariffs = []) => {
  const match = findTariffByCode(tariffCode, tariffs);
  return match?.tariffName || "";
};

const normalizeIbsDateForParse = (dateStr) => {
  if (!dateStr) return "";
  // "01-APR-22" → "01 APR 22" for parseConnectionDate
  return String(dateStr).trim().replace(/-/g, " ");
};

const formatIbsPhoneNo = (contactNo) => {
  if (!contactNo) return "";
  return String(contactNo)
    .replace(/\D/g, "")
    .replace(/^92/, "0");
};

const ChangeOfAttributesForm = () => {

  const { sourcePage } = useParams();
  const { token, name: userName, roleName, userId, code: userCode, roleId, selectedAdminCompanyCode } = useSelector((state) => state.auth)
  let userCompany = resolveDiscoCompanyCodeForBranding(
    userCode,
    roleId,
    selectedAdminCompanyCode,
  );
  const getWaterMarkLogo = (code) => {
    switch (code) {
      case '11':
        return LESCOWaterMark
      case '12':
        return GEPCOWaterMark
      case '13':
        return FESCOWaterMark
      case '14':
        return IESCOWaterMark
      case '15':
        return MEPCOWaterMark
      case '26':
        return PESCOWaterMark
      case '27':
        return HAZECOWaterMark
      case '37':
        return HESCOWaterMark
      case '38':
        return SEPCOWaterMark
      case '48':
        return QESCOWaterMark
      case '59':
        return TESCOWaterMark
      default:
        return MEPCOWaterMark
    }
  }
  const getLogo = (code) => {
    switch (code) {
      case '10':
        return pitcLogo
      case '11':
        return LESCOLOGO
      case '12':
        return GEPCOLOGO
      case '13':
        return FESCOLOGO
      case '14':
        return IESCOLOGO
      case '15':
        return MEPCOLOGO
      case '26':
        return PESCOLOGO
      case '27':
        return HAZECOLOGO
      case '37':
        return HESCOLOGO
      case '38':
        return SEPCOLOGO
      case '48':
        return QESCOLOGO
      case '59':
        return TESCOLOGO
      default:
        return MEPCOLOGO
    }
  }
  const [coaStatusBarArray, setCoaStatusBarArray] = useState(() =>
    buildCoaStatusBarSteps(null),
  );

  let navigate = useNavigate()
  //Defining all the states tobe used in page
  const [name, setName] = useState('');
  const [phoneNo, setPhoneNo] = useState('');
  const [cnicNo, setCnicNo] = useState('');
  const [email, setEmail] = useState('');
  const [sectionedLoad, setSectionedLoad] = useState('');
  const [referenceNumber, setReferenceNumber] = useState('');
  const [areaType, setAreaType] = useState('');
  const [referenceNumberForAPI, setReferenceNumberForAPI] = useState('');
  const [sanctionedType, setSanctionedType] = React.useState('');
  const [oldTariff, setOldTariff] = React.useState('');
  const [oldFatherName, setOldFatherName] = React.useState('');
  const [newTarif, setNewTarif] = React.useState('');
  const [tarifData, setTarifData] = React.useState([]);
  const [termCondition, setTermCondition] = useState('yes');
  const [isLoadingSpinner, setIsLoadingSpinner] = React.useState(false);
  const [pageTitle, setPageTitle] = useState('Change of Attributes Form')
  const [viewBackdrop, setViewBackdrop] = useState(false);

  const [applicationID, setApplicationID] = useState('');
  const [consumerID, setConsumerID] = useState('');
  const [lookUpDataOfCON, setLookUpDataOfCON] = useState(null);


  const [applicantCnicFront, setApplicantCnicDocumentFront] = useState('');
  const [applicantCnicFrontThumbnail, setApplicantCnicDocumentFrontThumbnail] = useState('');
  const [applicantCnicBack, setApplicantCnicDocumentBack] = useState('');
  const [applicantCnicBackThumbnail, setApplicantCnicDocumentBackThumbnail] = useState('');
  const [ownerShip, setOwnerShip] = useState('');
  const [electricityBill, setElectricityBill] = useState('');
  const [fbrDocument, setFbrDocument] = useState('');

  const [ownerShipThumbnail, setOwnerShipThumbnail] = useState('');
  const [electricityBillThumbnail, setElectricityBillThumbnail] = useState('');
  const [wiringTestReportDocument, setWiringTestReportDocument] = useState('');
  const [wiringTestReportDocumentThumbnail, setWiringTestReportDocumentThumbnail] = useState('');
  const [wiringTestReportDocumentError, setWiringTestReportDocumentError] = useState('');
  const [fbrThumbnail, setFbrThumbnail] = useState('');

  const [authorityLetter, setAuthorityLetter] = useState('');
  const [authorityLetterThumbnail, setAuthorityLetterThumbnail] = useState('');
  const [cnicPreviousOwnerFront, setCnicPreviousOwnerFront] = useState('');
  const [cnicPreviousOwnerFrontThumbnail, setCnicPreviousOwnerFrontThumbnail] = useState('');
  const [cnicPreviousOwnerBack, setCnicPreviousOwnerBack] = useState('');
  const [cnicPreviousOwnerBackThumbnail, setCnicPreviousOwnerBackThumbnail] = useState('');
  const [nocPreviousOwner, setNocPreviousOwner] = useState('');
  const [nocPreviousOwnerThumbnail, setNocPreviousOwnerThumbnail] = useState('');
  const [affidaviteApplicant, setAffidaviteApplicant] = useState('');
  const [affidaviteApplicantThumbnail, setAffidaviteApplicantThumbnail] = useState('');
  const [additionalCivicDocument, setAdditionalCivicDocument] = useState('');
  const [anyOtherDocument, setAnyOtherDocument] = useState('');
  const [consentImageChangeOfNameDocument, setConsentImageChangeOfNameDocument] = useState('');
  const [additionalCivicDocumentThumbnail, setAdditionalCivicDocumentThumbnail] = useState('');
  const [anyOtherDocumentThumbnail, setAnyOtherDocumentThumbnail] = useState('');
  const [consentImageChangeOfNameDocumentThumbnail, setConsentImageChangeOfNameDocumentThumbnail] = useState('');
  const [otherDocuments, setOtherDocuments] = useState('');
  const [otherDocumentsThumbnail, setOtherDocumentsThumbnail] = useState('');
  const [checked, setChecked] = useState(false);
  const [applicantCnicFrontError, setApplicantCnicFrontError] = useState('')
  const [applicantCnicBackError, setApplicantCnicBackError] = useState('')
  const [ownerShipError, setOwnerShipError] = useState("");
  const [electricityBillError, setElectricityBillError] = useState("");
  const [fbrError, setFbrError] = useState("");

  const [authorityLetterError, setAuthorityLetterError] = useState("");
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [cnicPreviousOwnerFrontError, setCnicPreviousOwnerFrontError] = useState('')
  const [cnicPreviousOwnerBackError, setCnicPreviousOwnerBackError] = useState('')
  const [nocPreviousOwnerError, setNocPreviousOwnerError] = useState("");
  const [affidaviteApplicantError, setAffidaviteApplicantError] = useState("");
  const [additionalCivicDocumentError, setAdditionalCivicDocumentError] = useState("");
  const [anyOtherDocumentError, setAnyOtherDocumentError] = useState("");
  const [consentImageChangeOfNameDocumentError, setConsentImageChangeOfNameDocumentError] = useState("");
  const [otherDocumentsError, setOtherDocumentsError] = useState("");

  const [error, setError] = useState('')

  const [successPopUp, setSuccessPopUp] = useState(false)
  const [successPopupTitle, setSuccessPopupTitle] = useState('')
  const [successPopupMessage, setSuccessPopupMessage] = useState('')

  const [searchBy, setSearchBy] = useState('referenceNo');
  const [hierarchyList, setHierarchyList] = useState([]);
  const [circleList, setCircleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);
  const [defaultCircle, setDefaultCircle] = useState();
  const [defaultDivision, setDefaultDivision] = useState();
  const [subDivision, setSubDivision] = React.useState({ code: null, name: '' });
  const [loadChangeType, setLoadChangeType] = useState("");
  const [selectedOptions, setSelectedOptions] = useState({
    name: false,
    load: false,
    tariff: false,
  });
  const [connectionDate, setConnectionDate] = useState('');


  const handleLoadChangeType = (e) => {
    const selectedTypeId = parseInt(e.target.value);
    values.iv_load_type = selectedTypeId
  };
  let subDivisionsArray = JSON.parse(
    window.localStorage.getItem("subDivisions")
  );
  //Defining Functions to set values in states
  const Name = event => {
    setName(event.target.value);
  };
  const PhoneNo = event => {
    event.preventDefault();
    setPhoneNo(event.target.value);
  };
  const CnicNo = event => {
    setCnicNo(event.target.value);
  };

  const Email = event => {
    setEmail(event.target.value);
  };

  const FatherName = event => {
    setOldFatherName(event.target.value);
  };

  const SectionedLoad = event => {
    setSectionedLoad(event.target.value);
  };

  const SanctionedType = (event) => {
    handleChange(event)
    setSanctionedType(event.target.value)
  };

  const TarifData = (event) => {
    handleChange(event)
    setNewTarif(event.target.value);
  };

  const OldTariff = (event) => {
    setOldTariff(event.target.value)
  };

  const ApplicantCnicDocumentFront = (event) => {
    const newFileName = 'copyOfApplicantCNICFront.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setApplicantCnicDocumentFront, setApplicantCnicFrontError, setApplicantCnicDocumentFrontThumbnail, newFileName);
  };

  const ApplicantCnicDocumentBack = (event) => {
    const newFileName = 'copyOfApplicantCNICBack.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setApplicantCnicDocumentBack, setApplicantCnicBackError, setApplicantCnicDocumentBackThumbnail, newFileName);
  };

  const OwnerShip = (event) => {
    const newFileName = 'ownership.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setOwnerShip, setOwnerShipError, setOwnerShipThumbnail, newFileName);
  };

  const ApplicantElectricityBill = (event) => {
    const newFileName = 'electricityBill.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setElectricityBill, setElectricityBillError, setElectricityBillThumbnail, newFileName);
  };

  const WiringTestReportDocument = (event) => {
    const newFileName = 'wiringTestReport.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(
      event,
      handleChange,
      setWiringTestReportDocument,
      setWiringTestReportDocumentError,
      setWiringTestReportDocumentThumbnail,
      newFileName
    );
  };

  const ApplicantFbr = (event) => {
    const newFileName = 'fbrDoc.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setFbrDocument, setFbrError, setFbrThumbnail, newFileName);
  };

  const ApplicantAnyOtherDocument = (event) => {
    const newFileName = 'anyOtherDocument.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setAnyOtherDocument, setAnyOtherDocumentError, setAnyOtherDocumentThumbnail, newFileName);
  };

  const AuthorityLetter = (event) => {
    const newFileName = 'authorityLetter.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setAuthorityLetter, setAuthorityLetterError, setAuthorityLetterThumbnail, newFileName);
  };

  const PreviousOwnerCNICFront = (event) => {
    const newFileName = 'previousOwnerCNICFront.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setCnicPreviousOwnerFront, setCnicPreviousOwnerFrontError, setCnicPreviousOwnerFrontThumbnail, newFileName);
  };

  const PreviousOwnerCNICBack = (event) => {
    const newFileName = 'previousOwnerCNICBack.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setCnicPreviousOwnerBack, setCnicPreviousOwnerBackError, setCnicPreviousOwnerBackThumbnail, newFileName);
  };

  const NocPreviousOwner = (event) => {
    const newFileName = 'nocPreviousOwner.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setNocPreviousOwner, setNocPreviousOwnerError, setNocPreviousOwnerThumbnail, newFileName);
  };

  const AffidaviteApplicant = (event) => {
    const newFileName = 'affidaviteApplicant.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setAffidaviteApplicant, setAffidaviteApplicantError, setAffidaviteApplicantThumbnail, newFileName);
  };

  const AdditionalCivicDocument = (event) => {
    const newFileName = 'additionalCivicDocument.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setAdditionalCivicDocument, setAdditionalCivicDocumentError, setAdditionalCivicDocumentThumbnail, newFileName);
  };

  const AnyOtherDocument = (event) => {
    const newFileName = 'anyOtherDocument.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setAnyOtherDocument, setAnyOtherDocumentError, setAnyOtherDocumentThumbnail, newFileName);
  };

  const OtherDocuments = (event) => {
    const newFileName = 'otherDocuments.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setOtherDocuments, setOtherDocumentsError, setOtherDocumentsThumbnail, newFileName);
  };
  const ConsentImageOfChangeOfNameDocuments = (event) => {
    const newFileName = 'consentImageChangeOfName.' + event.target.files[0].name.split(".").pop();
    handleFileUpload(event, handleChange, setConsentImageChangeOfNameDocument, setConsentImageChangeOfNameDocumentError, setConsentImageChangeOfNameDocumentThumbnail, newFileName);
  };

  const errorCloses = () => {
    setError('')
  }

  const handleChangeApplyChangeOfName = () => {
    setChecked(!checked);
  };

  const printApplicationReceipt = (
    values,
    applicationID,
    userName,
    applicationTypeName,
    roleName,
    referenceNumber,
    previousValues = {},
  ) => {
    const subDivisionCode = String(
      values.iv_sub_divison ??
        values.iv_subdivision ??
        String(referenceNumber || "").replace(/\s/g, "").slice(2, 7) ??
        ""
    );
    let DiscoCode = subDivisionCode.slice(0, 2) || String(referenceNumber || "").slice(2, 4);
    const doc = new jsPDF({ compressPdf: true });

    // Generate the barcode image using JsBarcode
    const barcodeCanvas = document.createElement("canvas");
    JsBarcode(barcodeCanvas, applicationID);

    // Convert the barcode image to data URL
    const barcodeDataURL = barcodeCanvas.toDataURL("image/png");
    var height = 10;
    var padding = 10;
    const smallLogoCodes = ['12', '13', '11', '16', '26', '27', '48', '59'];
    var pageWidth = doc.internal.pageSize.getWidth();

    const logoWidth = smallLogoCodes.includes(DiscoCode) ? 25 : 30;
    const logoHeight = smallLogoCodes.includes(DiscoCode) ? 15 : 8;
    // Get page width

    // Calculate X position to center the logo
    const logoX = (pageWidth - logoWidth) / 2;
    // Add the barcode image to the PDF document

    // Add the barcode image to the PDF document
    doc.addImage(barcodeDataURL, "PNG", 85, 260, 40, 20); // Adjust the position and size of the barcode image
    doc.addImage(getLogo(DiscoCode), "PNG", logoX, height, logoWidth, logoHeight); // Adjust the position and size of the logo image

    height = height + 20;

    var increment = 10;
    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.text(
      "Receipt of " + applicationTypeName,
      doc.internal.pageSize.getWidth() / 2,
      height,
      {
        align: "center",
      }
    );
    doc.setFontSize(12);
    increment = 20;
    height = height + increment;
    var leftMargin = 120;
    doc.text("DISCO / Company: ", padding, height);
    doc.text("Sub Division Code & Name:", padding + leftMargin, height);

    doc.setFont("helvetica", "normal");
    increment = 10;
    height = height + increment;
    leftMargin = 120;
    doc.text(
      companyShortName(referenceNumber.toString().slice(2, 4)),
      padding,
      height
    );
    doc.text(
      referenceNumber.toString().slice(2, 7) +
      " / " +
      subdivisionName(parseInt(referenceNumber.toString().slice(2, 7)), subDivisionsArray),
      padding + leftMargin,
      height
    );


    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");

    increment = 10;
    height = height + increment;

    doc.text("Issued By:", padding, height);
    doc.text("Designation:", padding + leftMargin, height);

    doc.setFont("helvetica", "normal");

    increment = 10;
    height = height + increment;

    leftMargin = 120;

    doc.text(
      userName,
      padding,
      height
    );

    doc.text(
      roleName,
      padding + leftMargin,
      height
    );


    increment = 10;
    height = height + increment;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);

    doc.text("Applicant Details", doc.internal.pageSize.getWidth() / 2, height, {
      align: "center",
    });

    const displayOrDash = (value) => {
      const text = value == null ? "" : String(value).trim();
      return text || "-";
    };
    const displayLoad = (value) => {
      const text = displayOrDash(value);
      if (text === "-") return text;
      return /kw/i.test(text) ? text : `${text} kW`;
    };

    const previousName = displayOrDash(values.iv_applicant_name);
    const newName = displayOrDash(values.iv_new_name) === "-"
      ? previousName
      : displayOrDash(values.iv_new_name);
    const previousLoad = displayLoad(
      previousValues.previousLoad ?? sectionedLoad,
    );
    const newLoad = displayOrDash(values.iv_new_load) === "-"
      ? previousLoad
      : displayLoad(values.iv_new_load);
    const previousTariff = displayOrDash(
      previousValues.previousTariff ?? oldTariff,
    );
    const newTariff = displayOrDash(values.iv_new_tariff) === "-"
      ? previousTariff
      : displayOrDash(values.iv_new_tariff);

    var currentDate = new Date();
    var formattedDate = currentDate.getDate() + ' ' +
      ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][currentDate.getMonth()] + ' ' +
      currentDate.getFullYear();

    const selectedChanges = previousValues.selected || {};
    const showName =
      selectedChanges.name === true || applicationTypeName.includes("Name");
    const showLoad =
      selectedChanges.load === true || applicationTypeName.includes("Load");
    const showTariff =
      selectedChanges.tariff === true || applicationTypeName.includes("Tariff");

    const detailRows = [
      ["Tracking ID:", applicationID.toString(), "Application Date:", formattedDate],
      ["Reference No.:", referenceNumber, "Mobile No.:", values.iv_applicant_phone_no],
    ];

    if (showName) {
      detailRows.push(
        ["Previous Name:", previousName, "New Name:", newName],
        ["Previous CNIC:", values.iv_applicant_cnic, "New CNIC:", values.iv_new_cnic],
        ["Previous F. Name:", values.iv_father_name, "New F. Name:", values.iv_new_father_name],
      );
    }
    if (showLoad) {
      detailRows.push(["Previous Load:", previousLoad, "New Load:", newLoad]);
    }
    if (showTariff) {
      detailRows.push(
        ["Previous Tariff:", previousTariff, "New Tariff:", newTariff],
      );
    }

    const labelGap = 3;
    const columnGap = 10;
    const leftColX = padding;
    const rightColX = pageWidth / 2 + 2;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    const leftLabelWidth = Math.max(
      ...detailRows.map(([leftLabel]) => doc.getTextWidth(leftLabel)),
    );
    const rightLabelWidth = Math.max(
      ...detailRows.map(([, , rightLabel]) => doc.getTextWidth(rightLabel)),
    );
    const leftValueX = leftColX + leftLabelWidth + labelGap;
    const rightValueX = rightColX + rightLabelWidth + labelGap;
    const leftValueWidth = Math.max(24, rightColX - leftValueX - columnGap);
    const rightValueWidth = Math.max(24, pageWidth - padding - rightValueX);

    const printAlignedRow = (leftLabel, leftValue, rightLabel, rightValue) => {
      increment = 8;
      height = height + increment;
      const leftLines = doc.splitTextToSize(displayOrDash(leftValue), leftValueWidth);
      const rightLines = doc.splitTextToSize(displayOrDash(rightValue), rightValueWidth);

      doc.setFont("helvetica", "bold");
      doc.text(leftLabel, leftColX, height);
      doc.setFont("helvetica", "normal");
      doc.text(leftLines, leftValueX, height);

      doc.setFont("helvetica", "bold");
      doc.text(rightLabel, rightColX, height);
      doc.setFont("helvetica", "normal");
      doc.text(rightLines, rightValueX, height);

      const extraLines = Math.max(leftLines.length, rightLines.length) - 1;
      if (extraLines > 0) {
        height = height + extraLines * 5;
      }
    };

    detailRows.forEach((row) => printAlignedRow(...row));

    const totalPages = doc.internal.getNumberOfPages();

    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.addImage(
        getWaterMarkLogo(userCompany),
        "PNG",
        0,
        0,
        doc.internal.pageSize.getWidth(),
        doc.internal.pageSize.getHeight()
      );
    }

    const pdfBlob = doc.output('blob');
    const pdfDataUrl = URL.createObjectURL(pdfBlob);

    window.open(pdfDataUrl, '_blank');

  };

  const handleClose = () => {
    setSuccessPopUp(false);
    navigate('/change-of-attributes-table');
  };

  const SearchBy = (event) => {
    values.iv_search_by = event.target.value;
    setSearchBy(event.target.value);
    setDefaultCircle('')
    setDefaultDivision('')
    setSubDivision('')
    values.iv_consumer_id = ''
    values.iv_reference_number = ''

    values.iv_applicant_name = ''
    values.iv_father_name = ''
    values.iv_applicant_cnic = ''
    values.iv_applicant_address = ''

    values.iv_applicant_phone_no = ''
    values.iv_applicant_email = ''
    values.iv_new_name = ""
    values.iv_new_cnic = ""
    values.iv_new_email = ""
    values.iv_new_phone_no = ""
    values.iv_new_father_name = ''
    values.iv_load_type = ""
    values.iv_new_load = ""
    values.iv_new_tariff = ""
    values.iv_applicant_cnic_front = ""
    values.iv_applicant_cnic_back = ""
    values.iv_ownership_document = ""
    values.iv_previous_owner_cnic_front = ''
    values.iv_load_type = ""
    values.iv_application_type = ""
    values.iv_relation_type = ""
    values.iv_previous_owner_cnic_back = ''
    values.iv_noc_from_previous_owner = ''
    values.iv_new_owner_affidavite = ""
    values.iv_additional_civic_document = ''
    values.iv_any_other_document = ""
    values.iv_test_report = ""
    values.iv_other_documents = ""
    values.name = ''
    values.phoneNo = ''
    values.email = ''
    values.oldFatherName = ''
    setName()
    setOldFatherName()
    setPhoneNo()
    setEmail()
    values.iv_name = ''
    values.iv_cnic = ''
    values.iv_applicant_address = ''
    values.iv_connection_type = ''
    values.iv_tariff_description = ''
    values.iv_tariff_code = ''
    values.iv_applicant_name = ''
    values.iv_father_name = ''
    values.iv_applicant_cnic = ''
    values.iv_applicant_address = ''
    values.iv_applicant_phone_no = ''
    values.iv_applicant_email = ''
    values.iv_meter_type = ''
    values.iv_phase = ''
    setSectionedLoad('')
    setChecked(false)
  };

  const getChangeOfText = (options) => {
    // 1. Convert true values into an array of capitalized titles
    const selected = Object.keys(options)
      .filter(key => options[key])
      .map(key => key.charAt(0).toUpperCase() + key.slice(1));

    // 2. Build final text
    if (selected.length === 1) {
      return `Change of ${selected[0]}`;
    }

    if (selected.length === 2) {
      return `Change of ${selected[0]} and ${selected[1]}`;
    }

    // 3 or more
    return `Change of ${selected.slice(0, -1).join(", ")} and ${selected[selected.length - 1]}`;
  };

  const getSuccessPopupContent = (options) => {
    const changeTypeText = getChangeOfText(options);
    return {
      title: `${changeTypeText} request entered`,
      message: `Your ${changeTypeText} request is submitted successfully.`,
    };
  };


  function parseConnectionDate(dateStr) {
    if (!dateStr) return null; // handle empty/null
    const months = {
      JAN: 0, FEB: 1, MAR: 2, APR: 3, MAY: 4, JUN: 5,
      JUL: 6, AUG: 7, SEP: 8, OCT: 9, NOV: 10, DEC: 11
    };

    const parts = dateStr.trim().split(/\s+/); // split by any spaces
    if (parts.length !== 3) return null;

    const [dayStr, monthStr, yearStr] = parts;
    const dayNum = parseInt(dayStr, 10);
    const monthNum = months[monthStr.toUpperCase()];
    const yearNum = 2000 + parseInt(yearStr, 10);

    if (isNaN(dayNum) || monthNum === undefined || isNaN(yearNum)) return null;

    return new Date(yearNum, monthNum, dayNum);
  }



  const { values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldError } = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_reference_number: Yup.string().when('iv_search_by', {
        is: () => searchBy === 'referenceNo',
        then: Yup.string().min(14, 'Reference No. must be 14 digits.').max(14, 'Reference No. must be 14 digits.').required("Enter reference number."),
        otherwise: Yup.string().optional()
      }),
      iv_consumer_id: Yup.string().when('iv_search_by', {
        is: () => searchBy === 'consumerId',
        then: buildCustomerIdYupRule(userCompany),
        otherwise: Yup.string().optional()
      }),
      iv_new_name: Yup.string().when("iv_application_type", {
        is: (val) => [1, 4, 5, 6].includes(val),
        then: (schema) =>
          schema
            .required("Enter new name.")
            .matches(ALPHABETIC_NAME_PATTERN, "Name must contain only alphabets."),
        otherwise: (schema) => schema.optional(),
      }),
      iv_telco: Yup.string()
        .required("Please select a Telco.")
        .test(
          "valid-telco",
          "Please select a Telco.",
          (value) => ["1", "2", "3", "4", "5"].includes(String(value ?? "").trim())
        ),
      iv_new_cnic: Yup.string().when("iv_application_type", {
        is: (val) => [1, 4, 5, 6].includes(val),
        then: (schema) =>
          schema
            .required("Enter new CNIC.")
            .matches(/^\d+$/, "CNIC must contain only numbers.")
            .min(13, "CNIC must be exactly 13 digits.")
            .max(13, "CNIC must be exactly 13 digits."),
        otherwise: (schema) => schema.optional(),
      }),

      iv_application_type: Yup.mixed()
        .test(
          'apply-for-change-of',
          'Apply for change of is required.',
          (value) => value != null && [1, 2, 3, 4, 5, 6, 7].includes(Number(value)),
        ),

      iv_applicant_phone_no: Yup.string()
        .required("Phone number is required")
        .matches(/^03[0-9]{9}$/, "Phone number must start with 03 and be 11 digits long"),

      iv_new_father_name: Yup.string().when(
        ["iv_application_type", "iv_relation_type"],
        (iv_application_type, iv_relation_type, schema) => {
          if ([1, 4, 5, 6].includes(iv_application_type)) {
            let relationLabel = "";

            if ([1, 2].includes(iv_relation_type)) relationLabel = "father's";
            else if (iv_relation_type === 3) relationLabel = "husband's";
            else if (iv_relation_type === 4) relationLabel = "care of's";

            return schema
              .required(`Enter ${relationLabel} new name.`)
              .matches(
                ALPHABETIC_NAME_PATTERN,
                "Name must contain only alphabets.",
              );
          }
          return schema.optional();
        }
      ),


      iv_new_email: Yup.string().when("iv_application_type", {
        is: (val) => [1, 2, 3, 4, 5, 6, 7].includes(val),
        then: Yup.string().email("Enter email as 'john@gmail.com'."),
        otherwise: Yup.string().optional(),
      }),

      iv_new_load: Yup.number().when("iv_application_type", {
        is: (val) => [2, 4, 5, 7].includes(val),
        then: (schema) =>
          schema
            .typeError("Enter new load in numbers!")
            .required("New load is required!")
            .test(
              "load-change-direction",
              "Invalid load change.",
              function (value) {
                const newLoad = Number(value);
                if (!Number.isFinite(newLoad)) return true;

                const sanctionedLoad = Number(
                  String(sectionedLoad ?? "")
                    .replace(/,/g, "")
                    .trim(),
                );
                if (!Number.isFinite(sanctionedLoad)) return true;

                const selectedTypeId = Number(this.parent.iv_load_type);
                if (!selectedTypeId) return true;

                const selectedType = lookUpDataOfCON?.lookupLoadChangeType?.find(
                  (item) => Number(item.typeId) === selectedTypeId,
                );
                const typeName = String(selectedType?.typeName || "").toLowerCase();

                if (typeName.includes("addition")) {
                  return newLoad > sanctionedLoad
                    ? true
                    : this.createError({
                        message:
                          "For Addition, new load must be greater than sanctioned load.",
                      });
                }

                if (typeName.includes("reduction")) {
                  return newLoad < sanctionedLoad
                    ? true
                    : this.createError({
                        message:
                          "For Reduction, new load must be less than sanctioned load.",
                      });
                }

                return true;
              },
            ),
        otherwise: (schema) => schema.optional(),
      }),
      iv_load_type: Yup.number().when("iv_application_type", {
        is: (val) => [2, 4, 5, 7].includes(val),
        then: (schema) =>
          schema
            .typeError("Select load change type!")
            .required("Load change type is required!"),
        otherwise: (schema) => schema.optional(),
      }),
      iv_relation_type: Yup.number().when("iv_application_type", {
        is: (val) => [1, 4, 5, 6].includes(val),
        then: (schema) =>
          schema
            .typeError("Select relation type!")
            .required("Relation type is required!"),
        otherwise: (schema) => schema.optional(),
      }),

      iv_new_tariff: Yup.string().when("iv_application_type", {
        is: (val) => [3, 4, 6, 7].includes(val),
        then: (schema) =>
          schema
            .required("Select new tariff.")
            .test(
              "not-empty",
              "Select new tariff.",
              (value) => value && value.trim() !== ""
            ),
        otherwise: (schema) => schema.optional(),
      }),

      iv_ntn_num: Yup.string().when('iv_new_tariff', {
        is: (val) => {
          if (!val) return false;
          const cleaned = val.replace('-', ''); // 🔹 remove dash if present (e.g., "A-2" → "A2")
          return cleaned.startsWith('A2') || cleaned.startsWith('B');
        },
        then: (schema) =>
          schema
            .required('NTN No. is required')
            .matches(/^\d+$/, 'NTN must contain only numbers')
            .min(7, 'NTN must be at least 7 digits')
            .max(13, 'NTN must be at most 13 digits'),
        otherwise: (schema) => schema.notRequired(),
      }),


      iv_applicant_cnic_front: Yup.mixed().required('Applicant CNIC Front is required'),
      iv_applicant_cnic_back: Yup.mixed().required('Applicant CNIC Back is required'),
      iv_ownership_document: Yup.mixed().required("Ownership proof is required"),
      iv_electricity_bill_document: Yup.mixed().required("Electricity Bill is required"),
      iv_test_report: Yup.mixed().when('iv_application_type', {
        is: (val) => requiresWiringTestReport(val),
        then: (schema) => schema.required('Wiring Test Report is required'),
        otherwise: (schema) => schema.notRequired(),
      }),
      iv_any_other_document: Yup.mixed().nullable().notRequired(),
      iv_other_documents: Yup.mixed().nullable().notRequired(),

      iv_fbr_document: Yup.mixed().when('iv_new_tariff', {
        is: (val) => {
          if (!val) return false;
          const cleaned = val.replace('-', ''); // 🔹 remove any dash
          return cleaned.startsWith('A2') || cleaned.startsWith('B');
        },
        then: (schema) => schema.required('FBR Doc. is required'),
        otherwise: (schema) => schema.notRequired(),
      }),

    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      setIsLoadingSpinner(true);

      // File validations
      if (!applicantCnicFrontThumbnail) {
        setApplicantCnicFrontError('Upload Applicant CNIC front document in JPG, PNG or PDF.');
      } else if (!applicantCnicBackThumbnail) {
        setApplicantCnicBackError('Upload Applicant CNIC back document in JPG, PNG or PDF.');
      } else if (!ownerShipThumbnail) {
        setOwnerShipError('Upload Ownership document in JPG, PNG or PDF.');
      } else if (!electricityBillThumbnail) {
        setElectricityBillError('Upload Electricity Bill in JPG, PNG or PDF.');
      } else if (
        requiresWiringTestReport(values.iv_application_type) &&
        !wiringTestReportDocumentThumbnail
      ) {
        setWiringTestReportDocumentError(
          'Upload Wiring Test Report in JPG, PNG or PDF.'
        );
        setIsLoadingSpinner(false);
        setViewBackdrop(false);
        return;
      } if (
        oldTariff?.replace('-', '').charAt(0) === 'D' &&
        values.iv_new_tariff?.replace('-', '').charAt(0) === 'B'
      ) {

        const connectionDateObj = parseConnectionDate(connectionDate);

        if (!connectionDateObj || isNaN(connectionDateObj)) {
          setError("Invalid connection date.");
          setIsLoadingSpinner(false);
          setViewBackdrop(false);
          return;
        }
        
        const today = new Date();
        const diffMs = today - connectionDateObj;
        const diffYears = diffMs / (1000 * 60 * 60 * 24 * 365);
        
        if (diffYears >= 1) {
          apiCalling(values)
        } else {
          setError("Connection must be at least 1 year old to move from D to B.");
          setIsLoadingSpinner(false);
          setViewBackdrop(false);
        }
      }
      else {
        apiCalling(values)
      }

      // setIsLoadingSpinner(false);
      // setViewBackdrop(false);
    }
  })


  const apiCalling = async (values) => {
    setViewBackdrop(true);
    const currentOwnerName = [
      values.iv_applicant_name?.trim(),
      values.iv_father_name?.trim()
    ]
      .filter(Boolean) // Remove empty, null, undefined
      .join(' ');
    // const currentOwnerName = `${values.iv_applicant_name} ${values.iv_father_name}`;

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    // Build request payload
    const raw = {
      areaType: areaType,
      referenceNumber,
      customerId: consumerID,
      applicationProgressId: 1,
      submittedThrough: portalName,
      remarks: "Application Submitted.",
      changeOfAttributesType: values.iv_application_type,
      connectionType: values.iv_connection_type,
      currentOwnerName,
      currentOwnerCNIC: values.iv_applicant_cnic || "",
      currentOwnerPhoneNo: values.iv_applicant_phone_no || "",
      currentOwnerEmail: values.iv_applicant_email || "",
      consumerAddress: values.iv_applicant_address || "",
      telcoCode: values.iv_telco,
      changeOfLoadType: values.iv_load_type || "",
      currentSanctionLoad: sectionedLoad || "",
      newSanctionLoad: values.iv_new_load || "",

      // Tariff info
      currentTariff: oldTariff || "",
      newTariff: values.iv_new_tariff || "",

      // Documents
      applicantCNICFront: applicantCnicFrontThumbnail || "",
      applicantCNICBack: applicantCnicBackThumbnail || "",
      electricityBill: electricityBillThumbnail || "",
      wiringTestReportDocument: wiringTestReportDocumentThumbnail || "",
      ownershipImage: ownerShipThumbnail || "",
      fbrDocument: fbrThumbnail || "",
      ntnNo: values.iv_ntn_num,
      anyOtherDocument : anyOtherDocumentThumbnail || "",
      ...([1, 4, 5, 6].includes(Number(values.iv_application_type))
        ? {
          applicantName: values.iv_new_name || "",
          applicantGuardianType: values.iv_relation_type || "",
          applicantGuardianName: values.iv_new_father_name || "",
          applicantCNIC: values.iv_new_cnic || "",
          applicantPhoneNo: values.iv_applicant_phone_no || "",
          applicantEmail: values.iv_new_email || "",
        }
        : {
          applicantName: values.iv_applicant_name || "",
          applicantGuardianType: values.iv_relation_type || "",
          applicantGuardianName: values.iv_father_name || "",
          applicantCNIC: values.iv_applicant_cnic || "",
          applicantPhoneNo: values.iv_applicant_phone_no || "",
          applicantEmail: values.iv_applicant_email || "",
        }
      ),
    };

    try {
      const response = await fetch(
        cfpBaseUrl + "changeOfAttributes/registerChangeOfAttributes",
        {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(raw),
          redirect: "follow",
        }
      );

      const result = await response.json();

      if (result.status === "200" || result.status === 200) {
        const applicationID = result.applicationId;
        setViewBackdrop(false);
        setIsLoadingSpinner(false);
        setError("");

        setApplicationID(applicationID);

        // Print receipt before clearing form so Previous Load / Tariff stay available
        try {
          printApplicationReceipt(
            values,
            applicationID,
            userName,
            getChangeOfText(selectedOptions),
            roleName,
            referenceNumber,
            {
              previousLoad: sectionedLoad,
              previousTariff: oldTariff,
              selected: selectedOptions,
            },
          );
        } catch (printError) { /* ignored */ }

        setName('');
        setCnicNo('');
        setPhoneNo('');
        setEmail('');
        setSectionedLoad('');
        setOldTariff('');
        setOldFatherName('');
        setApplicantCnicDocumentFront('');
        setApplicantCnicDocumentBack('');
        setOwnerShip('');
        setElectricityBill('');
        values.iv_load_type = ""
        values.iv_application_type = ""
        values.iv_relation_type = ""
        setLoadChangeType('');
        setApplicantCnicDocumentFrontThumbnail('');
        setApplicantCnicDocumentBackThumbnail('');
        setOwnerShipThumbnail('');
        setElectricityBillThumbnail('');
        setWiringTestReportDocument('');
        setWiringTestReportDocumentThumbnail('');
        setWiringTestReportDocumentError('');
        setAnyOtherDocument('');
        setAnyOtherDocumentThumbnail('');
        setFbrDocument('');
        setFbrThumbnail('');

        const popupContent = getSuccessPopupContent(selectedOptions);
        setSuccessPopupTitle(popupContent.title);
        setSuccessPopupMessage(popupContent.message);
        setSuccessPopUp(true);
      } else {
        setViewBackdrop(false);
        setIsLoadingSpinner(false);
        setError(result.message || "Something went wrong while submitting the form.");
      }
    } catch (error) {
      setViewBackdrop(false);
      setIsLoadingSpinner(false);
      setError("Something went wrong while submitting the form.");
    }
  }
  // Fetch consumer particulars from IBS getConsumerDetails (replaces DupBill API)
  const refrenceapi = async () => {
    const searchValue =
      searchBy === "consumerId"
        ? String(values.iv_consumer_id || "").replace(/\s/g, "")
        : String(values.iv_reference_number || "").replace(/\s/g, "");

    if (!searchValue) return;

    setViewBackdrop(true);
    try {
      const apiResponse = await getConsumerDetails(token, searchValue);

      if (
        (apiResponse?.status === "200" || apiResponse?.status === 200) &&
        Array.isArray(apiResponse?.data) &&
        apiResponse.data.length > 0
      ) {
        const consumer = apiResponse.data[0];
        const connectionMessage = getConsumerConnectionStatusMessage(
          consumer.CURRENT_STATUS
        );
        if (connectionMessage) {
          setError(connectionMessage);
          setIsDataLoaded(false);
          return;
        }

        setError("");

        const refNoRaw = String(consumer.REF_NO || "").replace(/\s/g, "");
        const refNo = refNoRaw.slice(0, 14);
        const customerId = String(consumer.CUSTOMER_ID || "");
        const phoneNo = formatIbsPhoneNo(consumer.CONTACT_NO) || "03000000000";
        const cnic = consumer.CNIC ? String(consumer.CNIC) : "0000000000000";
        const sanctionLoad = consumer.SANCTION_LOAD ?? "";
        const meterCount = Number(
          consumer.TOTAL_KWH_METERS || consumer.TOTAL_SETS || 1
        );
        const meterKind = Number(consumer.IS_AMR) === 1 ? "AMR" : "NORMAL";
        const phaseLabel = String(consumer.METER_TYPE || "")
          .toUpperCase()
          .includes("THREE")
          ? "3-PHASE"
          : "1-PHASE";

        let tariffs = tarifData;
        if (!tariffs?.length) {
          tariffs = (await tariffListAPI()) || [];
        }
        const tariffCode = consumer.TARIFF_CODE || "";
        const matchedTariff = findTariffByCode(tariffCode, tariffs);
        const tariffName =
          matchedTariff?.tariffName ||
          resolveTariffNameFromList(tariffCode, tariffs) ||
          getConnectionTypeFromTariffCode(tariffCode);
        // Prefer category (consumerType) from getTariffsDetail match
        const connectionType =
          getConnectionCategoryFromTariffList(tariffCode, tariffs) ||
          getConnectionTypeFromTariffCode(tariffCode);
        // IBS getConsumerDetails: AREA_TYPE is "0" (Rural → R) or "1" (Urban → U)
        const areaTypeRaw = String(consumer.AREA_TYPE ?? "")
          .trim()
          .toUpperCase();
        const areaFromRef = String(refNoRaw.slice(-1) || "")
          .trim()
          .toUpperCase();
        const mapAreaType = (value) => {
          if (value === "0" || value === "R") return "R";
          if (value === "1" || value === "U") return "U";
          return "";
        };
        const area =
          mapAreaType(areaTypeRaw) ||
          mapAreaType(areaFromRef) ||
          "";

        values.iv_applicant_name = consumer.CUSTOMER_NAME || "";
        values.iv_father_name = consumer.NAME_SWDO || "";
        values.iv_applicant_cnic = consumer.CNIC || "";
        values.iv_applicant_address = consumer.ADDRESS || "";
        values.iv_applicant_phone_no = phoneNo;
        values.iv_applicant_email = consumer.EMAIL || "";
        values.iv_name = consumer.CUSTOMER_NAME || "";
        values.iv_cnic = consumer.CNIC || "";
        values.iv_consumer_id = customerId;
        values.iv_reference_number = refNo;
        values.iv_tariff_code = tariffCode;
        values.iv_tariff_description = tariffName;
        values.iv_connection_type = connectionType;
        values.iv_meter_type = getMeterType(
          null,
          meterKind,
          phaseLabel,
          meterCount
        );
        values.iv_phase = getPhase(sanctionLoad) || consumer.METER_TYPE || "";
        values.iv_subdivision = refNo.length >= 7 ? refNo.slice(2, 7) : "";
        values.iv_sub_divison =
          refNo.length >= 7 ? Number(refNo.slice(2, 7)) || refNo.slice(2, 7) : "";

        setConsumerID(customerId);
        setConnectionDate(normalizeIbsDateForParse(consumer.SECURITY_DATE));
        setName(consumer.CUSTOMER_NAME || "");
        setCnicNo(cnic);
        setPhoneNo(phoneNo);
        setEmail(consumer.EMAIL || "example@gmail.com");
        setReferenceNumber(refNo);
        setReferenceNumberForAPI(refNoRaw);
        setAreaType(area);
        setSectionedLoad(sanctionLoad);
        setOldTariff(tariffName);
        setOldFatherName(consumer.NAME_SWDO || "");
        setIsDataLoaded(true);
      } else if (apiResponse?.status === "400" || apiResponse?.status === 400) {
        setIsDataLoaded(false);
        setError(
          apiResponse.message ||
            apiResponse.innerMessage ||
            (searchBy === "consumerId"
              ? "Customer ID. does not exist!"
              : "Reference number does not exist!")
        );
      } else {
        setIsDataLoaded(false);
        setError(
          searchBy === "consumerId"
            ? "Customer ID. does not exist!"
            : "Reference number does not exist!"
        );
      }
    } catch (e) {
      setIsDataLoaded(false);
      setError("An error occurred while fetching consumer details.");
    } finally {
      setViewBackdrop(false);
    }
  };

  // Defining function to fetch tariffs list
  const tariffListAPI = async () => {
    var formdata = new FormData();
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    var requestOptions = {
      method: 'POST',
      body: formdata,
      headers: myHeaders,
      redirect: 'follow',
    }
    let tariffs = [];
    try {
      const response = await fetch(
        cfpBaseUrl + "customerFaciliationPortal/getTariffsDetail",
        requestOptions
      );
      const result = await response.json();
      if (result.status === "200" && Array.isArray(result.data)) {
        tariffs = result.data;
        setTarifData(result.data);
      }
    } catch (e) { /* ignored */ }
    return tariffs;
  };

  //To fetch tariffs list and current information from APIs
  useEffect(() => {
    if (isValidCustomerIdLength(values.iv_consumer_id, userCompany)) {
      tariffListAPI(); // function to fetch tariffs list from API 
      refrenceapi(); // function to fetch current information on behalf of reference number
    }
    else {
      setDefaultCircle('')
      setDefaultDivision('')
      setSubDivision('')
      values.iv_reference_number = ''
      values.iv_meter_type = ''
      values.iv_phase = ''
      values.iv_applicant_name = ''
      values.iv_father_name = ''
      values.iv_applicant_cnic = ''
      values.iv_applicant_address = ''

      values.iv_applicant_phone_no = ''
      values.iv_applicant_email = ''
      values.iv_new_name = ""
      values.iv_new_cnic = ""
      values.iv_new_email = ""
      values.iv_new_phone_no = ""
      values.iv_new_father_name = ''
      values.iv_load_type = ""
      values.iv_new_load = ""
      values.iv_new_tariff = ""
      values.iv_applicant_cnic_front = ""
      values.iv_applicant_cnic_back = ""
      values.iv_ownership_document = ""
      values.iv_previous_owner_cnic_front = ''
      values.iv_previous_owner_cnic_back = ''
      values.iv_noc_from_previous_owner = ''
      values.iv_new_owner_affidavite = ""
      values.iv_additional_civic_document = ''
      values.iv_test_report = ""
      values.iv_other_documents = ""
      values.name = ''
      values.phoneNo = ''
      values.email = ''
      values.oldFatherName = ''
      setName()
      setOldFatherName()
      setPhoneNo()
      setEmail()
      values.iv_name = ''
      values.iv_cnic = ''
      values.iv_load_type = ""
      values.iv_application_type = ""
      values.iv_relation_type = ""
      values.iv_applicant_address = ''
      values.iv_connection_type = ''
      values.iv_tariff_description = ''
      values.iv_tariff_code = ''
      setSectionedLoad('')
      setChecked(false)
      setApplicantCnicDocumentFrontThumbnail();
      setApplicantCnicDocumentBackThumbnail();
      setAnyOtherDocumentThumbnail('');
      setConsentImageChangeOfNameDocumentThumbnail('');
      setOwnerShipThumbnail();
      setCnicPreviousOwnerFrontThumbnail();
      setCnicPreviousOwnerBackThumbnail();
      setNocPreviousOwnerThumbnail();
      setAffidaviteApplicantThumbnail();
      setAdditionalCivicDocumentThumbnail();
      setConsentImageChangeOfNameDocument();
      setAnyOtherDocument();
      setAdditionalCivicDocument();
      setAffidaviteApplicant();
      setNocPreviousOwner();
      setCnicPreviousOwnerBack();
      setCnicPreviousOwnerFront();
      setAuthorityLetter();
      setOwnerShip();
      setApplicantCnicDocumentBack();
      setCnicPreviousOwnerFront();
      setSelectedOptions({
        name: false,
        load: false,
        tariff: false,
      });
    }
  }, [values.iv_consumer_id])

  useEffect(() => {
    if (values.iv_reference_number.length === 14) {
      tariffListAPI(); // function to fetch tariffs list from API 
      refrenceapi(); // function to fetch current information on behalf of reference number
    } else {
      setIsDataLoaded(false)
      setDefaultCircle('')
      setDefaultDivision('')
      setSubDivision('')
      values.iv_consumer_id = ''
      values.iv_applicant_name = ''
      values.iv_father_name = ''
      values.iv_applicant_cnic = ''
      values.iv_applicant_address = ''

      values.iv_applicant_phone_no = ''
      values.iv_applicant_email = ''
      values.iv_new_name = ""
      values.iv_new_cnic = ""
      values.iv_new_email = ""
      values.iv_new_phone_no = ""
      values.iv_new_father_name = ''
      values.iv_load_type = ""
      values.iv_new_load = ""
      values.iv_new_tariff = ""
      values.iv_applicant_cnic_front = ""
      values.iv_applicant_cnic_back = ""
      values.iv_ownership_document = ""
      values.iv_previous_owner_cnic_front = ''
      values.iv_previous_owner_cnic_back = ''
      values.iv_noc_from_previous_owner = ''
      values.iv_new_owner_affidavite = ""
      values.iv_additional_civic_document = ''
      values.iv_test_report = ""
      values.iv_other_documents = ""
      values.name = ''
      values.phoneNo = ''
      values.email = ''
      values.oldFatherName = ''
      values.iv_load_type = ""
      values.iv_application_type = ""
      values.iv_relation_type = ""
      setName()
      setOldFatherName()
      setPhoneNo()
      setEmail()
      values.iv_name = ''
      values.iv_cnic = ''
      values.iv_applicant_address = ''
      values.iv_connection_type = ''
      values.iv_tariff_description = ''
      values.iv_tariff_code = ''
      values.iv_phase = ''
      values.iv_meter_type = ''
      setSectionedLoad('')
      setChecked(false)
      setApplicantCnicDocumentFrontThumbnail();
      setApplicantCnicDocumentBackThumbnail();
      setAnyOtherDocumentThumbnail('');
      setConsentImageChangeOfNameDocumentThumbnail('');
      setOwnerShipThumbnail();
      setCnicPreviousOwnerFrontThumbnail();
      setCnicPreviousOwnerBackThumbnail();
      setNocPreviousOwnerThumbnail();
      setAffidaviteApplicantThumbnail();
      setAdditionalCivicDocumentThumbnail();
      setConsentImageChangeOfNameDocument();
      setAnyOtherDocument();
      setAdditionalCivicDocument();
      setAffidaviteApplicant();
      setNocPreviousOwner();
      setCnicPreviousOwnerBack();
      setCnicPreviousOwnerFront();
      setAuthorityLetter();
      setOwnerShip();
      setApplicantCnicDocumentBack();
      setCnicPreviousOwnerFront();
      setSelectedOptions({
        name: false,
        load: false,
        tariff: false,
      });
    }
  }, [values.iv_reference_number])

  useEffect(() => {
    if (referenceNumber.length === 14) {
      let enteredReferenceNo = referenceNumber;
      let circleCode = enteredReferenceNo.slice(2, 5);
      let circleObject = circleList.find(item => item.code === parseInt(circleCode));

      if (!circleObject) {
        setError(`Circle not found with code: ${circleCode}. Contact Admin!`);
        return;
      }

      setDefaultCircle(circleObject);
      values.iv_circle = circleObject.code;

      let divisionCode = enteredReferenceNo.slice(2, 6);
      let subDivisionCode = enteredReferenceNo.slice(2, 7);

      let uniqueDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const division = hierarchyList[i];
        if (division.circleCode === parseInt(circleCode)) {
          const existingDivision = uniqueDivisions.find(c => c.code === division.divisionCode);
          if (!existingDivision) {
            uniqueDivisions.push({
              code: division.divisionCode,
              name: division.divisionName,
            });
          }
        }
      }

      let sortedDivisionArray = uniqueDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
      );
      let defDivision = sortedDivisionArray.find(item => item.code === parseInt(divisionCode));

      if (!defDivision) {
        setError(`Division not found with code: ${divisionCode}. Contact Admin!`);
        return;
      }

      setDefaultDivision(defDivision);
      values.iv_division = defDivision.code;
      setDivisionList(sortedDivisionArray);

      let uniqueSubDivisions = [];

      for (let i = 0; i < hierarchyList.length; i++) {
        const subDivision = hierarchyList[i];
        if (subDivision.divisionCode === parseInt(divisionCode)) {
          const existingSubDivision = uniqueSubDivisions.find(c => c.code === subDivision.subDivisionCode);
          if (!existingSubDivision) {
            uniqueSubDivisions.push({
              code: subDivision.subDivisionCode,
              name: subDivision.subDivisionName,
            });
          }
        }
      }

      let sortedSubDivisionArray = uniqueSubDivisions.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
      );

      let subDivisionObject = sortedSubDivisionArray.find(item => item.code === parseInt(subDivisionCode));
      if (!subDivisionObject) {
        setError(`Subdivision not found with code: ${subDivisionCode}. Contact Admin!`);
        return;
      }

      values.iv_sub_divison = subDivisionObject.code;
      setSubDivision(subDivisionObject);
      setSubDivisionList(sortedSubDivisionArray);
    }
  }, [referenceNumber]);

  useEffect(() => {
    const loadSubDivs = async () => {
      if (userCompany && cfpBaseUrl && token) {
        setViewBackdrop(true)
        const lists = await subDivAPI(subDivisionsArray)
        setHierarchyList(lists.hierarchyList)
        setCircleList(lists.circleList)
        setDivisionList(lists.divisionList)
        setSubDivisionList(lists.subDivisionList)
        setViewBackdrop(false)
      }
    }
    loadSubDivs()
  }, []);

  useEffect(() => {
    setPageTitle("Change of Attributes")
    setCoaStatusBarArray((prev) => buildCoaStatusBarSteps(values.iv_application_type, prev))
  }, [])

  // Rebuild progress steps when change type changes (Wiring for all except typeId 1)
  useEffect(() => {
    setCoaStatusBarArray((prev) => buildCoaStatusBarSteps(values.iv_application_type, prev))
  }, [values.iv_application_type])

  // APPLICATION DETAIL step: filled when all required fields for selected change type are present
  useEffect(() => {
    const type = Number(values.iv_application_type);
    const hasRefOrCustomer =
      Boolean(String(values.iv_consumer_id || "").trim()) ||
      Boolean(String(values.iv_reference_number || "").trim());
    const hasPhone = Boolean(String(values.iv_applicant_phone_no || "").trim());
    const hasTelco = ["1", "2", "3", "4", "5"].includes(String(values.iv_telco ?? "").trim());

    const needsName = [1, 4, 5, 6].includes(type);
    const needsLoad = [2, 4, 5, 7].includes(type);
    const needsTariff = [3, 4, 6, 7].includes(type);

    const nameOk =
      !needsName ||
      (Boolean(String(values.iv_new_name || "").trim()) &&
        Boolean(String(values.iv_new_cnic || "").trim()) &&
        Boolean(String(values.iv_new_father_name || "").trim()) &&
        values.iv_relation_type !== "" &&
        values.iv_relation_type != null);

    const loadOk =
      !needsLoad ||
      (values.iv_new_load !== "" &&
        values.iv_new_load != null &&
        values.iv_load_type !== "" &&
        values.iv_load_type != null);

    const tariffValue = String(values.iv_new_tariff || "").trim();
    const cleanedTariff = tariffValue.replace("-", "");
    const needsNtn =
      needsTariff &&
      (cleanedTariff.startsWith("A2") || cleanedTariff.startsWith("B"));
    const tariffOk =
      !needsTariff ||
      (Boolean(tariffValue) &&
        (!needsNtn || Boolean(String(values.iv_ntn_num || "").trim())));

    const isApplicationDetailComplete =
      [1, 2, 3, 4, 5, 6, 7].includes(type) &&
      hasRefOrCustomer &&
      hasPhone &&
      hasTelco &&
      nameOk &&
      loadOk &&
      tariffOk;

    setCoaStepStatusByTitle(
      setCoaStatusBarArray,
      "APPLICATION",
      "DETAIL",
      isApplicationDetailComplete ? 1 : 0,
    );
  }, [
    values.iv_application_type,
    values.iv_consumer_id,
    values.iv_reference_number,
    values.iv_applicant_phone_no,
    values.iv_telco,
    values.iv_new_name,
    values.iv_new_cnic,
    values.iv_new_father_name,
    values.iv_relation_type,
    values.iv_new_load,
    values.iv_load_type,
    values.iv_new_tariff,
    values.iv_ntn_num,
  ])

  useEffect(() => {
    if (applicantCnicFront && applicantCnicBack) {
      setCoaStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[1] = {
          ...updatedArray[1],
          status: 1 // Set the status to the desired value
        };
        return updatedArray;
      })
    } else {
      setCoaStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[1] = {
          ...updatedArray[1],
          status: 0 // Set the status to the desired value
        };
        return updatedArray;
      })
    }
  }, [applicantCnicFront, applicantCnicBack])

  useEffect(() => {
    if (ownerShip) {
      setCoaStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[2] = {
          ...updatedArray[2],
          status: 1 // Set the status to the desired value
        };
        return updatedArray;
      })
    } else {
      setCoaStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[2] = {
          ...updatedArray[2],
          status: 0 // Set the status to the desired value
        };
        return updatedArray;
      })
    }
  }, [ownerShip])

  useEffect(() => {
    if (electricityBill) {
      setCoaStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[3] = {
          ...updatedArray[3],
          status: 1 // Set the status to the desired value
        };
        return updatedArray;
      })
    } else {
      setCoaStatusBarArray(prevArray => {
        const updatedArray = [...prevArray];
        updatedArray[3] = {
          ...updatedArray[3],
          status: 0 // Set the status to the desired value
        };
        return updatedArray;
      })
    }
  }, [electricityBill])

  useEffect(() => {
    if (!requiresWiringTestReport(values.iv_application_type)) {
      return;
    }
    setCoaStepStatusByTitle(
      setCoaStatusBarArray,
      'WIRING TEST',
      'REPORT',
      wiringTestReportDocument ? 1 : 0,
    );
  }, [wiringTestReportDocument, values.iv_application_type])

  useEffect(() => {
    setCoaStepStatusByTitle(
      setCoaStatusBarArray,
      'FBR',
      'DOCUMENT',
      fbrDocument ? 1 : 0,
    );
  }, [fbrDocument])

  useEffect(() => {
    if (values.iv_application_type === 0) {
      if (cnicPreviousOwnerFront && cnicPreviousOwnerBack) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[3] = {
            ...updatedArray[3],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
      } else {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[3] = {
            ...updatedArray[3],
            status: 0 // Set the status to the desired value
          };
          return updatedArray;
        })
      }
    }
  }, [cnicPreviousOwnerFront, cnicPreviousOwnerBack])

  useEffect(() => {
    if (values.iv_application_type === 0) {
      if (affidaviteApplicant) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[4] = {
            ...updatedArray[4],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
      } else {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[4] = {
            ...updatedArray[4],
            status: 0 // Set the status to the desired value
          };
          return updatedArray;
        })
      }
    }
  }, [affidaviteApplicant])

  useEffect(() => {
    if (values.iv_application_type === 0) {
      if (additionalCivicDocument) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[5] = {
            ...updatedArray[5],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
      } else {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[5] = {
            ...updatedArray[5],
            status: 0 // Set the status to the desired value
          };
          return updatedArray;
        })
      }
    }
  }, [additionalCivicDocument])

  useEffect(() => {
    setCoaStepStatusByTitle(
      setCoaStatusBarArray,
      'ANY OTHER',
      '(OPTIONAL)',
      anyOtherDocument ? 1 : 0,
    );
  }, [anyOtherDocument])

  useEffect(() => {
    if (values.iv_application_type === 0) {
      if (consentImageChangeOfNameDocument) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[7] = {
            ...updatedArray[7],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
      } else {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[7] = {
            ...updatedArray[7],
            status: 0 // Set the status to the desired value
          };
          return updatedArray;
        })
      }
    }
  }, [consentImageChangeOfNameDocument])

  useEffect(() => {
    if (values.iv_application_type === 2) {
      if (otherDocuments) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[4] = {
            ...updatedArray[4],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
      } else {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[3] = {
            ...updatedArray[3],
            status: 0 // Set the status to the desired value
          };
          return updatedArray;
        })
      }
    }
  }, [otherDocuments])

  useEffect(() => {
    if (values.iv_application_type === 2) {
      if (authorityLetter) {
        setCoaStatusBarArray(prevArray => {
          const updatedArray = [...prevArray];
          updatedArray[3] = {
            ...updatedArray[3],
            status: 1 // Set the status to the desired value
          };
          return updatedArray;
        })
        // } else {
        //   setCoaStatusBarArray(prevArray => {
        //     const updatedArray = [...prevArray];
        //     updatedArray[3] = {
        //       ...updatedArray[3],
        //       status: 0 // Set the status to the desired value
        //     };
        //     return updatedArray;
        //   })
      }
    }
  }, [authorityLetter])

  useEffect(() => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow"
    };

    fetch(cfpBaseUrl + "changeOfAttributes/getChangeOfAttributesLookupData", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === '200') {
          setLookUpDataOfCON(result.data)
        }
      })
      .catch(() => {});
  }, [token, cfpBaseUrl])

  const [typeValue, setTypeValue] = useState(() => {
    return typeof values?.iv_application_type === 'number' ? values.iv_application_type : null;
  });

  const computeTypeValue = ({ name, load, tariff }) => {
    if (name && load && tariff) return 4;
    if (name && load && !tariff) return 5;
    if (name && !load && tariff) return 6;
    if (!name && load && tariff) return 7;
    if (name && !load && !tariff) return 1;
    if (!name && load && !tariff) return 2;
    if (!name && !load && tariff) return 3;
    return null;
  };

  const handleCheckboxChange = (optionKey) => {
    const wasChecked = selectedOptions[optionKey] === true;
    const next = { ...selectedOptions, [optionKey]: !selectedOptions[optionKey] };
    const newTypeValue = computeTypeValue(next);
    setSelectedOptions(next);
    setTypeValue(newTypeValue);
    setFieldValue('iv_application_type', newTypeValue);
    setCoaStatusBarArray((prev) => buildCoaStatusBarSteps(newTypeValue, prev));

    // Uncheck → clear fields belonging to that change type
    if (wasChecked && optionKey === 'name') {
      setFieldValue('iv_new_name', '');
      setFieldValue('iv_relation_type', '');
      setFieldValue('iv_new_father_name', '');
      setFieldValue('iv_new_cnic', '');
      setFieldValue('iv_new_email', '');
      setFieldError('iv_new_name', undefined);
      setFieldError('iv_relation_type', undefined);
      setFieldError('iv_new_father_name', undefined);
      setFieldError('iv_new_cnic', undefined);
      setFieldError('iv_new_email', undefined);
    }

    if (wasChecked && optionKey === 'load') {
      setFieldValue('iv_load_type', '');
      setFieldValue('iv_new_load', '');
      setLoadChangeType('');
      setFieldError('iv_load_type', undefined);
      setFieldError('iv_new_load', undefined);
    }

    if (wasChecked && optionKey === 'tariff') {
      setFieldValue('iv_new_tariff', '');
      setFieldValue('iv_ntn_num', '');
      setFieldValue('iv_fbr_document', '');
      setFbrDocument('');
      setFbrThumbnail('');
      setFbrError('');
      setFieldError('iv_new_tariff', undefined);
      setFieldError('iv_ntn_num', undefined);
      setFieldError('iv_fbr_document', undefined);
    }

    // Wiring only required when type is not Change of Name only
    if (!requiresWiringTestReport(newTypeValue)) {
      setFieldError('iv_test_report', undefined);
      setWiringTestReportDocumentError('');
      setWiringTestReportDocument('');
      setWiringTestReportDocumentThumbnail('');
      setFieldValue('iv_test_report', '');
    }
  };

  const renderUploadSlot = ({
    file,
    thumbnail,
    onClear,
    onChange,
    inputId,
    inputName,
    buttonLabel = 'Upload',
    validationError,
    clientError,
    altText,
  }) => (
    <div className="upload-wrap">
      {file ? (
        <Button
          component="label"
          className="upload-preview"
          startIcon={
            <CloseIcon
              className="button-with-image"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                if (typeof onClear === 'function') {
                  onClear();
                }
              }}
            />
          }
        >
          {thumbnail && isImage(file) ? (
            <div className="btn-div">
              <img src={thumbnail} alt={altText} width="80" />
            </div>
          ) : isPdf(file) ? (
            <div className="btn-div">
              <img src={pdfIcon} alt="PDF" width="80" />
            </div>
          ) : (
            <span>Other file type</span>
          )}
        </Button>
      ) : (
        <>
          <Button
            variant="outlined"
            component="label"
            startIcon={<FileUploadOutlinedIcon />}
            className="btn"
          >
            {buttonLabel}
            <input
              hidden
              accept={documentExtensions}
              id={inputId}
              name={inputName}
              type="file"
              onChange={onChange}
            />
          </Button>
          {clientError ? <Box className="documentError">{clientError}</Box> : null}
          {validationError ? <Box className="documentError">{validationError}</Box> : null}
        </>
      )}
    </div>
  );

  return (
    <>
      <Grid container className="coa-page" sx={{ width: '100%', maxWidth: '100%' }}>
        <Box className="coa-container" sx={{ width: '100%', maxWidth: '100%' }}>
          <h3 className="heading coa-page-title">{pageTitle}</h3>
          <div className="coa-stepper-wrap">
            <StepProgressBar array={coaStatusBarArray} pageName="COA Form" />
          </div>

          <form onSubmit={handleSubmit} noValidate className="coa-form">
            <div className="section-card section-card--accent">
              <div className="section-title">Applicant&apos;s Particulars</div>
            <Grid container spacing={1} className="container coa-applicant-fields">

              <Grid item xs={12}>
                <Grid container spacing={1} alignItems="flex-end" className="coa-form-row coa-search-ref-row">

                  <Grid item xs={12} md={3}>
                    <Typography className="fieldLabel">Search By</Typography>
                    <FormControl className="form-control" fullWidth>
                      <RadioGroup row className="radio-group" name="iv_search_by" value={searchBy} onChange={SearchBy}>
                        <FormControlLabel value="referenceNo" control={<Radio size="small" />} label="Reference No." />
                        <FormControlLabel value="consumerId" control={<Radio size="small" />} label="Customer ID." />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={2}>
                    {searchBy === 'referenceNo' ? (
                      <>
                        <Typography className="fieldLabel">Reference No.</Typography>
                        <TextField
                          fullWidth
                          name="iv_reference_number"
                          value={values.iv_reference_number ?? ''}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 14 }}
                          className="textInputField coa-field-input"
                          autoComplete="off"
                          error={Boolean(touched.iv_reference_number && errors.iv_reference_number)}
                        />
                        {touched.iv_reference_number && errors.iv_reference_number && (
                          <Box className="from-Error">{errors.iv_reference_number}</Box>
                        )}
                      </>
                    ) : searchBy === 'consumerId' ? (
                      <>
                        <Typography className="fieldLabel">Customer ID.</Typography>
                        <TextField
                          fullWidth
                          name="iv_consumer_id"
                          value={values.iv_consumer_id ?? ''}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 10 }}
                          className="textInputField coa-field-input"
                          autoComplete="off"
                          error={Boolean(touched.iv_consumer_id && errors.iv_consumer_id)}
                        />
                        {touched.iv_consumer_id && errors.iv_consumer_id && (
                          <Box className="from-Error">{errors.iv_consumer_id}</Box>
                        )}
                      </>
                    ) : null}
                  </Grid>

                  <Grid item xs={12} md="auto" className="coa-change-grid-item">
                    <Typography className="fieldLabel">Apply for change of</Typography>
                    <Box className="coa-change-options">
                      <FormGroup row className="coa-change-checkboxes">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedOptions.name}
                              onChange={() => handleCheckboxChange('name')}
                              disabled={!isDataLoaded}
                              size="small"
                            />
                          }
                          label="Name"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedOptions.load}
                              onChange={() => handleCheckboxChange('load')}
                              disabled={!isDataLoaded}
                              size="small"
                            />
                          }
                          label="Load"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={selectedOptions.tariff}
                              onChange={() => handleCheckboxChange('tariff')}
                              disabled={!isDataLoaded}
                              size="small"
                            />
                          }
                          label="Tariff"
                        />
                      </FormGroup>
                    </Box>
                    {touched.iv_application_type && errors.iv_application_type && (
                      <Box className="from-Error">{errors.iv_application_type}</Box>
                    )}
                  </Grid>

                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid container spacing={1} alignItems="flex-start" className="coa-form-row">
                  <Grid item xs={12} md={3}>
                    <Typography className="fieldLabel">Current Owner Name</Typography>
                    <TextField
                      fullWidth
                      disabled
                      required
                      name="iv_applicant_name"
                      value={
                        values.iv_father_name
                          ? `${values.iv_applicant_name?.trim()} / ${values.iv_father_name?.trim()}`
                          : values.iv_applicant_name?.trim()
                      }
                      className="textInputField1 coa-field-input coa-field-input--disabled"
                    />
                    <Box className="from-Error">
                      {errors.iv_applicant_name && touched.iv_applicant_name ? errors.iv_applicant_name : null}
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Typography className="fieldLabel">NIC. / CNIC. / NICOP.</Typography>
                    <TextField
                      fullWidth
                      required
                      disabled
                      name="iv_applicant_cnic"
                      value={values.iv_applicant_cnic}
                      className="textInputField1 coa-field-input coa-field-input--disabled"
                    />
                    <Box className="from-Error">
                      {errors.iv_applicant_cnic && touched.iv_applicant_cnic ? errors.iv_applicant_cnic : null}
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <Typography className="fieldLabel">Address</Typography>
                    <TextField
                      fullWidth
                      required
                      disabled
                      name="iv_applicant_address"
                      value={values.iv_applicant_address}
                      className="textInputField1 coa-field-input coa-field-input--disabled"
                    />
                    <Box className="from-Error">
                      {errors.iv_applicant_address && touched.iv_applicant_address ? errors.iv_applicant_address : null}
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Typography className="fieldLabel">Telco</Typography>
                    <TextField
                      fullWidth
                      select
                      required
                      name="iv_telco"
                      value={values.iv_telco === 0 || values.iv_telco == null ? '' : String(values.iv_telco)}
                      onChange={(e) => {
                        handleChange({
                          target: {
                            name: 'iv_telco',
                            value: e.target.value,
                          },
                        });
                      }}
                      onBlur={handleBlur}
                      error={Boolean(touched.iv_telco && errors.iv_telco)}
                      className="textInputField coa-field-input"
                      SelectProps={{
                        displayEmpty: true,
                        renderValue: (selected) => {
                          if (selected === '' || selected == null) {
                            return <em className="coa-select-placeholder">Select Telco</em>;
                          }
                          const match = TELCO_OPTIONS.find((o) => o.value === String(selected));
                          return match?.label || String(selected);
                        },
                        MenuProps: THEME_SAFE_SELECT_MENU_PROPS,
                      }}
                    >
                      <MenuItem value="">
                        <em>Select Telco</em>
                      </MenuItem>
                      {TELCO_OPTIONS.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                          {opt.label}
                        </MenuItem>
                      ))}
                    </TextField>
                    {touched.iv_telco && errors.iv_telco && (
                      <Box className="from-Error">{errors.iv_telco}</Box>
                    )}
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Typography className="fieldLabel">Phone No.</Typography>
                    <TextField
                      fullWidth
                      required
                      name="iv_applicant_phone_no"
                      value={values.iv_applicant_phone_no}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      inputProps={{ maxLength: 11 }}
                      className="textInputField coa-field-input"
                    />
                    <Box className="from-Error">
                      {errors.iv_applicant_phone_no && touched.iv_applicant_phone_no ? errors.iv_applicant_phone_no : null}
                    </Box>
                  </Grid>
                </Grid>
              </Grid>

            {(values.iv_application_type == 1 || values.iv_application_type == 4 || values.iv_application_type == 5 || values.iv_application_type == 6) && (
              <Grid item xs={12}>
                <Grid container spacing={1} className="coa-form-row">
                  <Grid item xs={12} md={2}>
                    <Typography className="fieldLabel">New Name</Typography>
                    <TextField
                      fullWidth
                      required
                      name="iv_new_name"
                      value={values.iv_new_name}
                      onChange={(event) => {
                        handleChange({
                          target: {
                            name: "iv_new_name",
                            value: sanitizeAlphabeticNameInput(event.target.value),
                          },
                        });
                      }}
                      onBlur={handleBlur}
                      id="iv_new_name"
                      className="textInputField coa-field-input"
                    />
                    <Box className="from-Error">
                      {errors.iv_new_name && touched.iv_new_name ? errors.iv_new_name : null}
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Typography className="fieldLabel">Relation Type</Typography>
                    <FormControl fullWidth className="coa-select-field" error={touched.iv_relation_type && Boolean(errors.iv_relation_type)}>
                      <Select
                        variant="outlined"
                        displayEmpty
                        labelId="relation-type-label"
                        id="iv_relation_type"
                        name="iv_relation_type"
                        value={
                          values.iv_relation_type === '' || values.iv_relation_type == null
                            ? ''
                            : String(values.iv_relation_type)
                        }
                        onChange={(e) => {
                          const raw = e.target.value;
                          handleChange({
                            target: {
                              name: 'iv_relation_type',
                              value: raw === '' ? '' : parseInt(raw, 10),
                            },
                          });
                        }}
                        onBlur={handleBlur}
                        className="coa-select-input"
                        MenuProps={THEME_SAFE_SELECT_MENU_PROPS}
                        renderValue={(selected) => {
                          if (selected === '' || selected == null) {
                            return <em className="coa-select-placeholder">Select Relation Type</em>;
                          }
                          const match = lookUpDataOfCON?.lookupGuardianType?.find(
                            (item) => String(item.typeId) === String(selected)
                          );
                          return match?.typeName || String(selected);
                        }}
                      >
                        <MenuItem value="">
                          <em>Select Relation Type</em>
                        </MenuItem>
                        {lookUpDataOfCON?.lookupGuardianType.map((item) => (
                          <MenuItem key={item.typeId} value={String(item.typeId)}>
                            {item.typeName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <Box className="from-Error">
                      {errors.iv_relation_type && touched.iv_relation_type ? errors.iv_relation_type : null}
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Typography className="fieldLabel">
                      {(values.iv_relation_type == 1 || values.iv_relation_type == 2)
                        ? `Father's `
                        : values.iv_relation_type == 3
                          ? `Husband's `
                          : values.iv_relation_type == 4
                            ? 'Care of '
                            : 'Father of '}
                      Name
                    </Typography>
                    <TextField
                      fullWidth
                      required
                      name="iv_new_father_name"
                      value={values.iv_new_father_name}
                      autoComplete="off"
                      onChange={(event) => {
                        handleChange({
                          target: {
                            name: "iv_new_father_name",
                            value: sanitizeAlphabeticNameInput(event.target.value),
                          },
                        });
                      }}
                      onBlur={handleBlur}
                      id="iv_new_father_name"
                      className="textInputField coa-field-input"
                    />
                    <Box className="from-Error">
                      {errors.iv_new_father_name && touched.iv_new_father_name ? errors.iv_new_father_name : null}
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Typography className="fieldLabel">CNIC No.</Typography>
                    <TextField
                      fullWidth
                      required
                      name="iv_new_cnic"
                      value={values.iv_new_cnic}
                      onChange={(e) => {
                        const regex = /^[0-9\b]+$/;
                        if (e.target.value === '' || regex.test(e.target.value)) {
                          handleChange(e);
                        }
                      }}
                      onBlur={handleBlur}
                      inputProps={{ maxLength: 13 }}
                      id="newCnicNo"
                      className="textInputField coa-field-input"
                    />
                    <Box className="from-Error">
                      {errors.iv_new_cnic && touched.iv_new_cnic ? errors.iv_new_cnic : null}
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography className="fieldLabel">
                      Email<span className="email-optinal">(optional)</span>
                    </Typography>
                    <TextField
                      fullWidth
                      name="iv_new_email"
                      value={values.iv_new_email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="newEmail"
                      className="textInputField coa-field-input"
                    />
                    <Box className="from-Error">
                      {errors.iv_new_email && touched.iv_new_email ? errors.iv_new_email : null}
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            )}

            {(values.iv_application_type == 3 ||
              values.iv_application_type == 4 ||
              values.iv_application_type == 6 ||
              values.iv_application_type == 7) && (
              <Grid item xs={12}>
                <Grid container spacing={1} className="coa-form-row">
                  <Grid item xs={12} md={values.iv_new_tariff && values.iv_new_tariff.replace('-', '').match(/^(A2|B)/) ? 4 : 6}>
                    <Typography className="fieldLabel">Old Tariff</Typography>
                    <TextField
                      fullWidth
                      disabled
                      name="oldTariff"
                      value={oldTariff}
                      onChange={OldTariff}
                      id="oldTariff"
                      className="textInputField1 coa-field-input coa-field-input--disabled"
                    />
                  </Grid>

                  <Grid item xs={12} md={values.iv_new_tariff && values.iv_new_tariff.replace('-', '').match(/^(A2|B)/) ? 4 : 6}>
                    <Typography className="fieldLabel">New Tariff</Typography>
                    <FormControl fullWidth className="coa-select-field" error={touched.iv_new_tariff && Boolean(errors.iv_new_tariff)}>
                      <Select
                        variant="outlined"
                        displayEmpty
                        value={values.iv_new_tariff || ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name="iv_new_tariff"
                        id="iv_new_tariff"
                        className="coa-select-input"
                        MenuProps={THEME_SAFE_SELECT_MENU_PROPS}
                        renderValue={(selected) => {
                          if (!selected) {
                            return <em className="coa-select-placeholder">Select New Tariff</em>;
                          }
                          return selected;
                        }}
                      >
                        <MenuItem value="">
                          <em>Select New Tariff</em>
                        </MenuItem>
                        {tarifData.map((data, index) => (
                          <MenuItem key={index} value={data.tariffName}>
                            {data.tariffName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {touched.iv_new_tariff && errors.iv_new_tariff && (
                      <Box className="from-Error">{errors.iv_new_tariff}</Box>
                    )}
                  </Grid>

                  {values.iv_new_tariff &&
                    values.iv_new_tariff.replace('-', '').match(/^(A2|B)/) && (
                      <Grid item xs={12} md={4}>
                        <Typography className="fieldLabel">
                          NTN No.<span style={{ color: 'red' }}> *</span>
                        </Typography>
                        <TextField
                          fullWidth
                          required
                          name="iv_ntn_num"
                          value={values.iv_ntn_num}
                          onChange={(e) => {
                            const regex = /^[0-9\b]+$/;
                            if (e.target.value === '' || regex.test(e.target.value)) {
                              handleChange(e);
                            }
                          }}
                          onBlur={handleBlur}
                          inputProps={{ maxLength: 13 }}
                          className="textInputField coa-field-input"
                        />
                        <Box className="from-Error">
                          {errors.iv_ntn_num && touched.iv_ntn_num ? errors.iv_ntn_num : null}
                        </Box>
                      </Grid>
                    )}
                </Grid>
              </Grid>
            )}

            {(values.iv_application_type == 2 || values.iv_application_type == 4 || values.iv_application_type == 5 || values.iv_application_type == 7) && (
              <Grid item xs={12}>
                <Grid container spacing={1} className="coa-form-row">
                  <Grid item xs={12} md={4}>
                    <Typography className="fieldLabel">Load Change Type</Typography>
                    <FormControl fullWidth className="coa-select-field" error={touched.iv_load_type && Boolean(errors.iv_load_type)}>
                      <Select
                        variant="outlined"
                        displayEmpty
                        labelId="load-type-label"
                        id="iv_load_type"
                        name="iv_load_type"
                        value={
                          values.iv_load_type === '' || values.iv_load_type == null
                            ? ''
                            : String(values.iv_load_type)
                        }
                        onChange={(e) => {
                          const raw = e.target.value;
                          handleChange({
                            target: {
                              name: 'iv_load_type',
                              value: raw === '' ? '' : parseInt(raw, 10),
                            },
                          });
                        }}
                        onBlur={handleBlur}
                        className="coa-select-input"
                        MenuProps={THEME_SAFE_SELECT_MENU_PROPS}
                        renderValue={(selected) => {
                          if (selected === '' || selected == null) {
                            return <em className="coa-select-placeholder">Select Load Change Type</em>;
                          }
                          const match = lookUpDataOfCON?.lookupLoadChangeType?.find(
                            (item) => String(item.typeId) === String(selected)
                          );
                          return match?.typeName || String(selected);
                        }}
                      >
                        <MenuItem value="">
                          <em>Select Load Change Type</em>
                        </MenuItem>
                        {lookUpDataOfCON?.lookupLoadChangeType.map((item) => (
                          <MenuItem key={item.typeId} value={String(item.typeId)}>
                            {item.typeName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <Box className="from-Error">
                      {errors.iv_load_type && touched.iv_load_type ? errors.iv_load_type : null}
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography className="fieldLabel">Sanctioned Load (kW)</Typography>
                    <TextField
                      fullWidth
                      disabled
                      name="sectionedLoad"
                      value={sectionedLoad}
                      onChange={SectionedLoad}
                      id="sectionedLoad"
                      className="textInputField1 coa-field-input coa-field-input--disabled"
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography className="fieldLabel">New Load (kW)</Typography>
                    <TextField
                      fullWidth
                      required
                      name="iv_new_load"
                      value={values.iv_new_load}
                      onChange={(e) => {
                        const regex = /^[0-9]*\.?[0-9]*$/;
                        if (e.target.value === '' || regex.test(e.target.value)) {
                          handleChange(e);
                        }
                      }}
                      onBlur={handleBlur}
                      inputProps={{ maxLength: 6 }}
                      id="newLoad"
                      className="textInputField coa-field-input"
                    />
                    <Box className="from-Error">
                      {errors.iv_new_load && touched.iv_new_load ? errors.iv_new_load : null}
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            )}

            </Grid>

            </div>

            <div className="section-card section-card--docs">
              <div className="section-title section-title--docs">
                <span>Required Documents</span>
                {values.iv_application_type === 0 && (
                  <a
                    href="https://eopsapi.pitc.com.pk:8040/CON%20Affidavit%20and%20NOC%20Temp.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="coa-template-link"
                  >
                    Download the template of NOC and Affidavite.
                  </a>
                )}
              </div>
              <Grid container spacing={2} className="documents-grid">
                <Grid item xs={12} sm={6} md={4} lg={4} className="coa-doc-col">
                  <div className="coa-doc-col-head">
                    <label className="fieldLabel doc-grid-label">1- Applicant&apos;s CNIC</label>
                  </div>
                  <div className="doc-grid-uploads cnic-upload-pair">
                    {renderUploadSlot({
                      file: applicantCnicFront,
                      thumbnail: applicantCnicFrontThumbnail,
                      onClear: () => {
                        setApplicantCnicDocumentFront('');
                        setApplicantCnicDocumentFrontThumbnail('');
                        setApplicantCnicFrontError('');
                        setFieldValue('iv_applicant_cnic_front', '');
                      },
                      onChange: ApplicantCnicDocumentFront,
                      inputId: 'iv_applicant_cnic_front',
                      inputName: 'iv_applicant_cnic_front',
                      buttonLabel: 'Front',
                      validationError: errors.iv_applicant_cnic_front || null,
                      clientError: applicantCnicFrontError || null,
                      altText: 'Applicant CNIC Front',
                    })}
                    {renderUploadSlot({
                      file: applicantCnicBack,
                      thumbnail: applicantCnicBackThumbnail,
                      onClear: () => {
                        setApplicantCnicDocumentBack('');
                        setApplicantCnicDocumentBackThumbnail('');
                        setApplicantCnicBackError('');
                        setFieldValue('iv_applicant_cnic_back', '');
                      },
                      onChange: ApplicantCnicDocumentBack,
                      inputId: 'iv_applicant_cnic_back',
                      inputName: 'iv_applicant_cnic_back',
                      buttonLabel: 'Back',
                      validationError: errors.iv_applicant_cnic_back || null,
                      clientError: applicantCnicBackError || null,
                      altText: 'Applicant CNIC Back',
                    })}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={4} className="coa-doc-col">
                  <div className="coa-doc-col-head">
                    <label className="fieldLabel doc-grid-label">2- Proof of Ownership</label>
                  </div>
                  <div className="doc-grid-uploads">
                    {renderUploadSlot({
                      file: ownerShip,
                      thumbnail: ownerShipThumbnail,
                      onClear: () => {
                        setOwnerShip('');
                        setOwnerShipThumbnail('');
                        setOwnerShipError('');
                        setFieldValue('iv_ownership_document', '');
                      },
                      onChange: OwnerShip,
                      inputId: 'iv_ownership_document',
                      inputName: 'iv_ownership_document',
                      validationError: errors.iv_ownership_document || null,
                      clientError: ownerShipError || null,
                      altText: 'Proof of Ownership',
                    })}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={4} className="coa-doc-col">
                  <div className="coa-doc-col-head">
                    <label className="fieldLabel doc-grid-label">3- Electricity Bill</label>
                  </div>
                  <div className="doc-grid-uploads">
                    {renderUploadSlot({
                      file: electricityBill,
                      thumbnail: electricityBillThumbnail,
                      onClear: () => {
                        setElectricityBill('');
                        setElectricityBillThumbnail('');
                        setElectricityBillError('');
                        setFieldValue('iv_electricity_bill_document', '');
                      },
                      onChange: ApplicantElectricityBill,
                      inputId: 'iv_electricity_bill_document',
                      inputName: 'iv_electricity_bill_document',
                      validationError: errors.iv_electricity_bill_document || null,
                      clientError: electricityBillError || null,
                      altText: 'Electricity Bill',
                    })}
                  </div>
                </Grid>
                {requiresWiringTestReport(values.iv_application_type) && (
                <Grid item xs={12} sm={6} md={4} lg={4} className="coa-doc-col">
                  <div className="coa-doc-col-head">
                    <label className="fieldLabel doc-grid-label">
                      4- Wiring Test Report
                    </label>
                  </div>
                  <div className="doc-grid-uploads">
                    {renderUploadSlot({
                      file: wiringTestReportDocument,
                      thumbnail: wiringTestReportDocumentThumbnail,
                      onClear: () => {
                        setWiringTestReportDocument('');
                        setWiringTestReportDocumentThumbnail('');
                        setWiringTestReportDocumentError('');
                        setFieldValue('iv_test_report', '');
                      },
                      onChange: WiringTestReportDocument,
                      inputId: 'iv_test_report',
                      inputName: 'iv_test_report',
                      validationError: errors.iv_test_report || null,
                      clientError: wiringTestReportDocumentError || null,
                      altText: 'Wiring Test Report',
                    })}
                  </div>
                </Grid>
                )}
                <Grid item xs={12} sm={6} md={4} lg={4} className="coa-doc-col">
                  <div className="coa-doc-col-head">
                    <label className="fieldLabel doc-grid-label">
                      {requiresWiringTestReport(values.iv_application_type) ? '5-' : '4-'} FBR Document
                    </label>
                  </div>
                  <div className="doc-grid-uploads">
                    {renderUploadSlot({
                      file: fbrDocument,
                      thumbnail: fbrThumbnail,
                      onClear: () => {
                        setFbrDocument('');
                        setFbrThumbnail('');
                        setFbrError('');
                        setFieldValue('iv_fbr_document', '');
                      },
                      onChange: ApplicantFbr,
                      inputId: 'iv_fbr_document',
                      inputName: 'iv_fbr_document',
                      validationError: errors.iv_fbr_document || null,
                      clientError: fbrError || null,
                      altText: 'FBR Document',
                    })}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={4} className="coa-doc-col">
                  <div className="coa-doc-col-head">
                    <label className="fieldLabel doc-grid-label">
                      {requiresWiringTestReport(values.iv_application_type) ? '6-' : '5-'} Any Other Document{' '}
                      <span style={{ color: '#A1A1A1' }}>(Optional)</span>
                    </label>
                  </div>
                  <div className="doc-grid-uploads">
                    {renderUploadSlot({
                      file: anyOtherDocument,
                      thumbnail: anyOtherDocumentThumbnail,
                      onClear: () => {
                        setAnyOtherDocument('');
                        setAnyOtherDocumentThumbnail('');
                        setAnyOtherDocumentError('');
                        setFieldValue('iv_any_other_document', '');
                      },
                      onChange: ApplicantAnyOtherDocument,
                      inputId: 'iv_any_other_document',
                      inputName: 'iv_any_other_document',
                      validationError: errors.iv_any_other_document || null,
                      clientError: anyOtherDocumentError || null,
                      altText: 'Any Other Document',
                    })}
                  </div>
                </Grid>
              </Grid>
            </div>
            {/* legacy optional docs block removed — see git history
                (values.iv_application_type !== 0 && values.iv_connection_type && !values.iv_connection_type.toLowerCase().startsWith('dom')) &&
                <>
                  <Grid item lg='1.75' >
                    <Typography className='documentLabel' >3- Authority Letter</Typography>
                    <Box className="documentError">
                      {
                        authorityLetterError ?
                          authorityLetterError : null
                      }
                    </Box>
                    <Box className="documentError">
                      {
                        errors.iv_authority_letter ?
                          errors.iv_authority_letter : null
                      }
                    </Box>
                  </Grid>
                  <Grid item lg='1.25'>
                    {authorityLetter ? (
                      <>
                        <Button
                          component="label"
                          startIcon={
                            <CloseIcon
                              className="button-with-image"
                              onClick={() => {
                                setAuthorityLetter("");
                              }}
                            />
                          }
                        >
                          {authorityLetterThumbnail &&
                            isImage(authorityLetter) ? (
                            <div className="btn-div">
                              <img
                                src={authorityLetterThumbnail}
                                alt="Ownership"
                                width="80"
                              />
                            </div>
                          ) : (
                            <span>
                              {isPdf(authorityLetter) ? (
                                <div className="btn-div">
                                  <img src={pdfIcon} alt="PDF" width="80" />
                                </div>
                              ) : (
                                "Other file type"
                              )}
                            </span>
                          )}
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          variant="outlined"
                          component="label"
                          startIcon={<FileUploadOutlinedIcon />}
                          className="btn"
                        >
                          Upload
                          <input
                            hidden
                            accept={documentExtensions}
                            id="iv_authority_letter"
                            name="iv_authority_letter"
                            type="file"
                            onChange={AuthorityLetter}
                          />
                        </Button>
                        <Box className="documentError">
                          {
                            authorityLetterError ?
                              authorityLetterError : null
                          }
                        </Box>
                        <Box className="documentError">
                          {
                            errors.iv_authority_letter ?
                              errors.iv_authority_letter : null
                          }
                        </Box>
                      </>
                    )}
                  </Grid>
                </>
              }
              {
                values.iv_application_type === 0 &&
                <>
                  <Grid item lg='1.25' >
                    <Typography className='documentLabel'>3- Previous Owner's CNIC.</Typography>


                  </Grid>
                  <Grid item lg={0.875}>
                    {
                      cnicPreviousOwnerFront ? (
                        <>
                          <Button
                            varient="outlined"
                            component="label"
                            startIcon={
                              <CloseIcon
                                className="button-with-image"
                                onClick={() => {
                                  setCnicPreviousOwnerFront("");
                                }}
                              />
                            }
                          >
                            {cnicPreviousOwnerFrontThumbnail &&
                              isImage(cnicPreviousOwnerFront) ? (
                              <div className="btn-div">
                                <img
                                  src={cnicPreviousOwnerFrontThumbnail}
                                  alt="Previous Owner CNIC Front"
                                  width="80"
                                />
                              </div>
                            ) : (
                              <span>
                                {isPdf(cnicPreviousOwnerFront) ? (
                                  <div className="btn-div">
                                    <img src={pdfIcon} alt="PDF" width="80" />
                                  </div>
                                ) : (
                                  "Other file type"
                                )}
                              </span>
                            )}
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<FileUploadOutlinedIcon />}
                            className="btn"
                          >
                            Front
                            <input
                              hidden
                              accept={documentExtensions}
                              id="iv_previous_owner_cnic_front"
                              name="iv_previous_owner_cnic_front"
                              type="file"
                              onChange={PreviousOwnerCNICFront}
                            />
                          </Button>
                          <Box className="documentError">
                            {
                              cnicPreviousOwnerFront == '' ?
                                cnicPreviousOwnerFrontError : null
                            }
                          </Box>
                          <Box className="documentError">
                            {errors.iv_previous_owner_cnic_front &&
                              touched.iv_previous_owner_cnic_front
                              ? errors.iv_previous_owner_cnic_front
                              : null}
                          </Box>
                        </>
                      )}
                  </Grid>
                  <Grid item lg={0.875}>
                    {cnicPreviousOwnerBack ? (
                      <>
                        <Button
                          component="label"
                          startIcon={
                            <CloseIcon
                              className="button-with-image"
                              onClick={() => {
                                setCnicPreviousOwnerBack("");
                              }}
                            />
                          }
                        >
                          {cnicPreviousOwnerBackThumbnail &&
                            isImage(cnicPreviousOwnerBack) ? (
                            <div className="btn-div">
                              <img
                                src={cnicPreviousOwnerBackThumbnail}
                                alt="Previous Owner CNIC Back"
                                width="80"
                              />
                            </div>
                          ) : (
                            <span>
                              {isPdf(cnicPreviousOwnerBack) ? (
                                <div className="btn-div">
                                  <img src={pdfIcon} alt="PDF" width="80" />
                                </div>
                              ) : (
                                "Other file type"
                              )}
                            </span>
                          )}
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          variant="outlined"
                          component="label"
                          startIcon={<FileUploadOutlinedIcon />}
                          className="btn"
                        >
                          Back
                          <input
                            hidden
                            accept={documentExtensions}
                            id="iv_previous_owner_cnic_back"
                            name="iv_previous_owner_cnic_back"
                            type="file"
                            onChange={PreviousOwnerCNICBack}
                          />
                        </Button>
                        <Box className="documentError">
                          {
                            cnicPreviousOwnerBack == '' ?
                              cnicPreviousOwnerBackError : null
                          }
                        </Box>
                        <Box className="documentError">
                          {errors.iv_previous_owner_cnic_back &&
                            touched.iv_previous_owner_cnic_back
                            ? errors.iv_previous_owner_cnic_back
                            : null}
                        </Box>
                      </>
                    )}
                  </Grid>
                  <Grid item lg='1.75' >
                    <Typography className='documentLabel'>4- Affidavite from Applicant</Typography>
                  </Grid>
                  <Grid item lg='1.25'>
                    {
                      affidaviteApplicant ? (
                        <>
                          <Button
                            component="label"
                            startIcon={
                              <CloseIcon
                                className="button-with-image"
                                onClick={() => {
                                  setAffidaviteApplicant("");
                                }}
                              />
                            }
                          >
                            {
                              affidaviteApplicantThumbnail &&
                                isImage(affidaviteApplicant) ? (
                                <div className="btn-div">
                                  <img
                                    src={affidaviteApplicantThumbnail}
                                    alt="Affidavite Applicant"
                                    width="80"
                                  />
                                </div>
                              ) : (
                                <span>
                                  {isPdf(affidaviteApplicant) ? (
                                    <div className="btn-div">
                                      <img src={pdfIcon} alt="PDF" width="80" />
                                    </div>
                                  ) : (
                                    "Other file type"
                                  )}
                                </span>
                              )
                            }
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<FileUploadOutlinedIcon />}
                            className="btn"
                          >
                            Upload
                            <input
                              hidden
                              accept={documentExtensions}
                              id="iv_new_owner_affidavite"
                              name="iv_new_owner_affidavite"
                              type="file"
                              onChange={AffidaviteApplicant}
                            />
                          </Button>
                          <Box className="documentError">
                            {
                              affidaviteApplicant == '' ?
                                affidaviteApplicantError : null
                            }
                          </Box>
                          <Box className='documentError'>{errors.iv_new_owner_affidavite && touched.iv_new_owner_affidavite ? (errors.iv_new_owner_affidavite) : null}</Box>

                        </>
                      )
                    }
                  </Grid>
                  <Grid item lg='1.75' >
                    <Typography className='documentLabel'>5- NOC from Previous Owner (opitional)</Typography>
                  </Grid>
                  <Grid item lg='1.25'>
                    {
                      nocPreviousOwner ? (
                        <>
                          <Button
                            component="label"
                            startIcon={
                              <CloseIcon
                                className="button-with-image"
                                onClick={() => {
                                  setNocPreviousOwner("");
                                }}
                              />
                            }
                          >
                            {
                              nocPreviousOwnerThumbnail &&
                                isImage(nocPreviousOwner) ? (
                                <div className="btn-div">
                                  <img
                                    src={nocPreviousOwnerThumbnail}
                                    alt="NOC Previous Owner"
                                    width="80"
                                  />
                                </div>
                              ) : (
                                <span>
                                  {isPdf(nocPreviousOwner) ? (
                                    <div className="btn-div">
                                      <img src={pdfIcon} alt="PDF" width="80" />
                                    </div>
                                  ) : (
                                    "Other file type"
                                  )}
                                </span>
                              )
                            }
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<FileUploadOutlinedIcon />}
                            className="btn"
                          >
                            Upload
                            <input
                              hidden
                              accept={documentExtensions}
                              id="iv_noc_from_previous_owner"
                              name="iv_noc_from_previous_owner"
                              type="file"
                              onChange={NocPreviousOwner}
                            />
                          </Button>
                          <Box className="documentError">
                            {
                              nocPreviousOwner == '' ?
                                nocPreviousOwnerError : null
                            }
                          </Box>
                          <Box className='documentError'>{errors.iv_noc_from_previous_owner && touched.iv_noc_from_previous_owner ? (errors.iv_noc_from_previous_owner) : null}</Box>

                        </>
                      )
                    }
                  </Grid>
                  <Grid item lg='1.75' >
                    <Typography className='documentLabel'>6- Additional Document from Civic Authority (opitional)</Typography>
                    <Box className='documentError'>{errors.iv_additional_civic_document && touched.iv_additional_civic_document ? (errors.iv_additional_civic_document) : null}</Box>
                  </Grid>
                  <Grid item lg='1.25'>
                    {
                      additionalCivicDocument ? (
                        <>
                          <Button
                            component="label"
                            startIcon={
                              <CloseIcon
                                className="button-with-image"
                                onClick={() => {
                                  setAdditionalCivicDocument("");
                                }}
                              />
                            }
                          >
                            {
                              additionalCivicDocumentThumbnail &&
                                isImage(additionalCivicDocument) ? (
                                <div className="btn-div">
                                  <img
                                    src={additionalCivicDocumentThumbnail}
                                    alt="Additional Civic Document"
                                    width="80"
                                  />
                                </div>
                              ) : (
                                <span>
                                  {isPdf(additionalCivicDocument) ? (
                                    <div className="btn-div">
                                      <img src={pdfIcon} alt="PDF" width="80" />
                                    </div>
                                  ) : (
                                    "Other file type"
                                  )}
                                </span>
                              )
                            }
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<FileUploadOutlinedIcon />}
                            className="btn"
                          >
                            Upload
                            <input
                              hidden
                              accept={documentExtensions}
                              id="iv_additional_civic_document"
                              name="iv_additional_civic_document"
                              type="file"
                              onChange={AdditionalCivicDocument}
                            />
                          </Button>
                          <Box className="documentError">
                            {
                              additionalCivicDocument == '' ?
                                additionalCivicDocumentError : null
                            }
                          </Box>
                        </>
                      )
                    }
                  </Grid>
                  <Grid item lg='1.75' >
                    <Typography className='documentLabel'>7- Any Other Document <span style={{ color: '#A1A1A1' }}>(Optional)</span></Typography>
                    <Box className='documentError'>{errors.iv_any_other_document && touched.iv_any_other_document ? (errors.iv_any_other_document) : null}</Box>
                  </Grid>
                  <Grid item lg='1.25'>
                    {
                      anyOtherDocument ? (
                        <>
                          <Button
                            component="label"
                            startIcon={
                              <CloseIcon
                                className="button-with-image"
                                onClick={() => {
                                  setAnyOtherDocument("");
                                }}
                              />
                            }
                          >
                            {
                              anyOtherDocumentThumbnail &&
                                isImage(anyOtherDocument) ? (
                                <div className="btn-div">
                                  <img
                                    src={anyOtherDocumentThumbnail}
                                    alt="Any Other Document"
                                    width="80"
                                  />
                                </div>
                              ) : (
                                <span>
                                  {isPdf(anyOtherDocument) ? (
                                    <div className="btn-div">
                                      <img src={pdfIcon} alt="PDF" width="80" />
                                    </div>
                                  ) : (
                                    "Other file type"
                                  )}
                                </span>
                              )
                            }
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<FileUploadOutlinedIcon />}
                            className="btn"
                          >
                            Upload
                            <input
                              hidden
                              accept={documentExtensions}
                              id="iv_any_other_document"
                              name="iv_any_other_document"
                              type="file"
                              onChange={AnyOtherDocument}
                            />
                          </Button>
                          <Box className="documentError">
                            {
                              anyOtherDocument == '' ?
                                anyOtherDocumentError : null
                            }
                          </Box>
                        </>
                      )
                    }
                  </Grid>
                  <Grid item lg='1.75' >
                    <Typography className='documentLabel'>8- Consent Image Change of Name (opitional)</Typography>
                    <Box className='documentError'>{errors.iv_consent_image_change_of_name && touched.iv_consent_image_change_of_name ? (errors.iv_consent_image_change_of_name) : null}</Box>
                  </Grid>
                  <Grid item lg='1.25'>
                    {
                      consentImageChangeOfNameDocument ? (
                        <>
                          <Button
                            component="label"
                            startIcon={
                              <CloseIcon
                                className="button-with-image"
                                onClick={() => {
                                  setConsentImageChangeOfNameDocument("");
                                }}
                              />
                            }
                          >
                            {
                              consentImageChangeOfNameDocumentThumbnail &&
                                isImage(consentImageChangeOfNameDocument) ? (
                                <div className="btn-div">
                                  <img
                                    src={consentImageChangeOfNameDocumentThumbnail}
                                    alt="Consent Image Change of Name Document"
                                    width="80"
                                  />
                                </div>
                              ) : (
                                <span>
                                  {isPdf(consentImageChangeOfNameDocument) ? (
                                    <div className="btn-div">
                                      <img src={pdfIcon} alt="PDF" width="80" />
                                    </div>
                                  ) : (
                                    "Other file type"
                                  )}
                                </span>
                              )
                            }
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<FileUploadOutlinedIcon />}
                            className="btn"
                          >
                            Upload
                            <input
                              hidden
                              accept={documentExtensions}
                              id="iv_consent_image_change_of_name"
                              name="iv_consent_image_change_of_name"
                              type="file"
                              onChange={ConsentImageOfChangeOfNameDocuments}
                            />
                          </Button>
                          <Box className="documentError">
                            {
                              consentImageChangeOfNameDocument == '' ?
                                consentImageChangeOfNameDocumentError : null
                            }
                          </Box>
                        </>
                      )
                    }
                  </Grid>
                </>
              }
              {
                values.iv_application_type === 2 &&
                <>
                  <Grid item lg='1.75' >
                    <Typography className='documentLabel'>4- Other Documents <span style={{ color: '#A1A1A1' }}>(Optional)</span></Typography>
                    <Box className='documentError'>{errors.iv_other_documents && touched.iv_other_documents ? (errors.iv_other_documents) : null}</Box>
                  </Grid>
                  <Grid item lg='1.25'>
                    {
                      otherDocuments ? (
                        <>
                          <Button
                            component="label"
                            startIcon={
                              <CloseIcon
                                className="button-with-image"
                                onClick={() => {
                                  setOtherDocuments("");
                                }}
                              />
                            }
                          >
                            {
                              otherDocumentsThumbnail &&
                                isImage(otherDocuments) ? (
                                <div className="btn-div">
                                  <img
                                    src={otherDocumentsThumbnail}
                                    alt="Other Documents"
                                    width="80"
                                  />
                                </div>
                              ) : (
                                <span>
                                  {isPdf(otherDocuments) ? (
                                    <div className="btn-div">
                                      <img src={pdfIcon} alt="PDF" width="80" />
                                    </div>
                                  ) : (
                                    "Other file type"
                                  )}
                                </span>
                              )
                            }
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<FileUploadOutlinedIcon />}
                            className="btn"
                          >
                            Upload
                            <input
                              hidden
                              accept={documentExtensions}
                              id="iv_other_documents"
                              name="iv_other_documents"
                              type="file"
                              onChange={OtherDocuments}
                            />
                          </Button>
                          <Box className="documentError">
                            {
                              otherDocuments == '' ?
                                otherDocumentsError : null
                            }
                          </Box>
                        </>
                      )
                    }
                  </Grid>
                </>
              } */}

            {error ? (
              <div className="coa-alert-wrap">
                <Error
                  error={error}
                  onClose={() => errorCloses()}
                  backgroundColor="#FFC0CB"
                  textColor="#bb0303"
                  iconColor="#bb0303"
                />
              </div>
            ) : null}

            <div className="submit-area">
              <Button
                className="submit-btn"
                variant="contained"
                type="submit"
                disabled={isLoadingSpinner}
              >
                {isLoadingSpinner ? 'Submitting...' : 'Submit'}
              </Button>
            </div>
          </form>
        </Box>
      </Grid >

      <FormSubmissionSuccessDialog
        open={successPopUp}
        onClose={handleClose}
        title={successPopupTitle}
        message={successPopupMessage}
        trackingId={applicationID}
        trackingLabel="Application ID"
      />


      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop >
    </>
  )

}

export default ChangeOfAttributesForm;
